var items = {
  "block.minecraft.acacia_button": "Akacia Button",
  "block.minecraft.acacia_door": "Acashuh Dor",
  "block.minecraft.acacia_fence": "Cat Fence",
  "block.minecraft.acacia_fence_gate": "ACAISHA GAIT",
  "block.minecraft.acacia_hanging_sign": "Acashuh Danglin' Sign",
  "block.minecraft.acacia_leaves": "savana lefs",
  "block.minecraft.acacia_log": "Acashuh lawg",
  "block.minecraft.acacia_planks": "Acashuh Plankz",
  "block.minecraft.acacia_pressure_plate": "Akacia Prseure Pleitz",
  "block.minecraft.acacia_sapling": "Baby Acashuh",
  "block.minecraft.acacia_shelf": "Acashuh Shelv",
  "block.minecraft.acacia_sign": "Acashuh Sign",
  "block.minecraft.acacia_slab": "Akacia Sleb",
  "block.minecraft.acacia_stairs": "Acaci Stairz",
  "block.minecraft.acacia_trapdoor": "Akacia Trap",
  "block.minecraft.acacia_wall_hanging_sign": "Acashuh Danglin' Sign On Da Wall",
  "block.minecraft.acacia_wall_sign": "Acashuh Sign on ur wall",
  "block.minecraft.acacia_wood": "Acashuh Wuud",
  "block.minecraft.activator_rail": "POWAAAAAAAAAAAH",
  "block.minecraft.air": "Aihr",
  "block.minecraft.allium": "Alollium",
  "block.minecraft.amethyst_block": "Purpul shinee bluk",
  "block.minecraft.amethyst_cluster": "Dun purpur shinee",
  "block.minecraft.ancient_debris": "super old stuffz",
  "block.minecraft.andesite": "grey rock",
  "block.minecraft.andesite_slab": "Grey Rock",
  "block.minecraft.andesite_stairs": "Grey Rock Stairz",
  "block.minecraft.andesite_wall": "Grey Rock Wal",
  "block.minecraft.anvil": "Anvehl",
  "block.minecraft.attached_melon_stem": "sticky melon stik",
  "block.minecraft.attached_pumpkin_stem": "Atachd pumpkin stem",
  "block.minecraft.azalea": "Turtl-shel-laik trea",
  "block.minecraft.azalea_leaves": "Les pretehh lefs",
  "block.minecraft.azure_bluet": "Bloo flowre",
  "block.minecraft.bamboo": "Green Stick",
  "block.minecraft.bamboo_block": "Thicc bamboo",
  "block.minecraft.bamboo_button": "Cat stick pressablz",
  "block.minecraft.bamboo_door": "Gren Dor",
  "block.minecraft.bamboo_fence": "Gren Stik Fence",
  "block.minecraft.bamboo_fence_gate": "Gren stik Gaet",
  "block.minecraft.bamboo_hanging_sign": "gren banzuk Danglin' Sign",
  "block.minecraft.bamboo_mosaic": "Gren blok",
  "block.minecraft.bamboo_mosaic_slab": "Fansi Gren Smol Blok",
  "block.minecraft.bamboo_mosaic_stairs": "Gren blok Smoll blok",
  "block.minecraft.bamboo_planks": "Litle gren stick Plankz",
  "block.minecraft.bamboo_pressure_plate": "gren blukz presurr plete",
  "block.minecraft.bamboo_sapling": "littl baby green stik",
  "block.minecraft.bamboo_shelf": "Gren Stik Shelv",
  "block.minecraft.bamboo_sign": "gren blukz sign",
  "block.minecraft.bamboo_slab": "Gren Smol Blocc",
  "block.minecraft.bamboo_stairs": "BAMBOOO climby blukz",
  "block.minecraft.bamboo_trapdoor": "Gren Trapdur",
  "block.minecraft.bamboo_wall_hanging_sign": "gren banzuk Danglin' Sign On Da Wall",
  "block.minecraft.bamboo_wall_sign": "gren blukz wol book",
  "block.minecraft.banner.base.black": "BLAK",
  "block.minecraft.banner.base.blue": "BLU",
  "block.minecraft.banner.base.brown": "BROUN",
  "block.minecraft.banner.base.cyan": "SAYAN",
  "block.minecraft.banner.base.gray": "GREY",
  "block.minecraft.banner.base.green": "GREN",
  "block.minecraft.banner.base.light_blue": "LAIGHT BLU",
  "block.minecraft.banner.base.light_gray": "LITTER COLUR",
  "block.minecraft.banner.base.lime": "LAIM\n",
  "block.minecraft.banner.base.magenta": "MEOWENTA",
  "block.minecraft.banner.base.orange": "ORENG",
  "block.minecraft.banner.base.pink": "PAW COLUR",
  "block.minecraft.banner.base.purple": "PURRP",
  "block.minecraft.banner.base.red": "RED",
  "block.minecraft.banner.base.white": "WITE",
  "block.minecraft.banner.base.yellow": "YLOW",
  "block.minecraft.banner.border.black": "Blak Burdur",
  "block.minecraft.banner.border.blue": "Blu Brdur",
  "block.minecraft.banner.border.brown": "Brown burdur",
  "block.minecraft.banner.border.cyan": "Sighan Burdur",
  "block.minecraft.banner.border.gray": "Gra Burdur",
  "block.minecraft.banner.border.green": "Gren Burdur",
  "block.minecraft.banner.border.light_blue": "Lite bloo burdur",
  "block.minecraft.banner.border.light_gray": "Lite Gra Burdur",
  "block.minecraft.banner.border.lime": "Lim Burdur",
  "block.minecraft.banner.border.magenta": "Majenta burdur",
  "block.minecraft.banner.border.orange": "Ornge burdur",
  "block.minecraft.banner.border.pink": "Pnk Burdur",
  "block.minecraft.banner.border.purple": "Purrrrple Burdur",
  "block.minecraft.banner.border.red": "Redd Burdur",
  "block.minecraft.banner.border.white": "Wite burdur",
  "block.minecraft.banner.border.yellow": "Yallow Brdur",
  "block.minecraft.banner.bricks.black": "BRIK PATTURN!",
  "block.minecraft.banner.bricks.blue": "covert in emo briks",
  "block.minecraft.banner.bricks.brown": "Broun briks",
  "block.minecraft.banner.bricks.cyan": "Nyan briks",
  "block.minecraft.banner.bricks.gray": "Grey briks",
  "block.minecraft.banner.bricks.green": "Grean briks",
  "block.minecraft.banner.bricks.light_blue": "covert in laight blue briks",
  "block.minecraft.banner.bricks.light_gray": "Lite Grey briks",
  "block.minecraft.banner.bricks.lime": "lemi Feld mazond",
  "block.minecraft.banner.bricks.magenta": "Majenta Feild Masoneded",
  "block.minecraft.banner.bricks.orange": "coverd in oringe briks",
  "block.minecraft.banner.bricks.pink": "Pink briks",
  "block.minecraft.banner.bricks.purple": "Purpal briks",
  "block.minecraft.banner.bricks.red": "Red briks",
  "block.minecraft.banner.bricks.white": "wit fel mazon",
  "block.minecraft.banner.bricks.yellow": "covert in yella briks",
  "block.minecraft.banner.circle.black": "Black Rundel",
  "block.minecraft.banner.circle.blue": "Bluu Rundel",
  "block.minecraft.banner.circle.brown": "Bruwn Rundel",
  "block.minecraft.banner.circle.cyan": "Cyan Rundel",
  "block.minecraft.banner.circle.gray": "Gry Rundel",
  "block.minecraft.banner.circle.green": "Gren Rundel",
  "block.minecraft.banner.circle.light_blue": "Light Bluu Rundel",
  "block.minecraft.banner.circle.light_gray": "Light Gry Rundel",
  "block.minecraft.banner.circle.lime": "Laim Rundel",
  "block.minecraft.banner.circle.magenta": "Magnta Rundel",
  "block.minecraft.banner.circle.orange": "Orang Rundel",
  "block.minecraft.banner.circle.pink": "Pinkie Raundl",
  "block.minecraft.banner.circle.purple": "Purpl Rundel",
  "block.minecraft.banner.circle.red": "Red Rundel",
  "block.minecraft.banner.circle.white": "Whit Rundel",
  "block.minecraft.banner.circle.yellow": "Yello Rundel",
  "block.minecraft.banner.creeper.black": "Bleck Creeper Churge",
  "block.minecraft.banner.creeper.blue": "Bleu Creeper Churge",
  "block.minecraft.banner.creeper.brown": "Brouwn Creeper Churge",
  "block.minecraft.banner.creeper.cyan": "Saiyan Creeper Chanj",
  "block.minecraft.banner.creeper.gray": "Grey Creeper Churge",
  "block.minecraft.banner.creeper.green": "Gren Creeper Churge",
  "block.minecraft.banner.creeper.light_blue": "Lite Bleu Creeper Churge",
  "block.minecraft.banner.creeper.light_gray": "Lite Grey Creeper Churge",
  "block.minecraft.banner.creeper.lime": "Laim Creeper Churge",
  "block.minecraft.banner.creeper.magenta": "Majenter Creeper Churge",
  "block.minecraft.banner.creeper.orange": "Oraynj Creeper Churge",
  "block.minecraft.banner.creeper.pink": "Pynk Creeper Churge",
  "block.minecraft.banner.creeper.purple": "Purr pol Creeper Churge",
  "block.minecraft.banner.creeper.red": "Ried Creeper Churge",
  "block.minecraft.banner.creeper.white": "Wite Creeper Churge",
  "block.minecraft.banner.creeper.yellow": "Yelo Creeper Churge",
  "block.minecraft.banner.cross.black": "Blak Saltir",
  "block.minecraft.banner.cross.blue": "Bloo Saltir",
  "block.minecraft.banner.cross.brown": "Brwn Saltir",
  "block.minecraft.banner.cross.cyan": "Cyan Saltir",
  "block.minecraft.banner.cross.gray": "Gra Saltir",
  "block.minecraft.banner.cross.green": "Gren Saltir",
  "block.minecraft.banner.cross.light_blue": "Lite Bloo Saltir",
  "block.minecraft.banner.cross.light_gray": "Lite Gra Saltir",
  "block.minecraft.banner.cross.lime": "Lim Salitr",
  "block.minecraft.banner.cross.magenta": "Majenta Saltir",
  "block.minecraft.banner.cross.orange": "Ornge Salitr",
  "block.minecraft.banner.cross.pink": "Pinc Saltir",
  "block.minecraft.banner.cross.purple": "Purrrrrrrple Saltir",
  "block.minecraft.banner.cross.red": "Red Salltir",
  "block.minecraft.banner.cross.white": "Wite Saltir",
  "block.minecraft.banner.cross.yellow": "Yelo Saltir",
  "block.minecraft.banner.curly_border.black": "Blek bordur idedendededed",
  "block.minecraft.banner.curly_border.blue": "Bloo burdur indentd",
  "block.minecraft.banner.curly_border.brown": "Broun burdur indentd",
  "block.minecraft.banner.curly_border.cyan": "Nyan burdur indentd",
  "block.minecraft.banner.curly_border.gray": "Grey burdur indentd",
  "block.minecraft.banner.curly_border.green": "Grean burdur indentd",
  "block.minecraft.banner.curly_border.light_blue": "Lite bloo burdur indentd",
  "block.minecraft.banner.curly_border.light_gray": "Lite Grey burdur indentd",
  "block.minecraft.banner.curly_border.lime": "Lyem burdur indentd",
  "block.minecraft.banner.curly_border.magenta": "Majenta burdur indentd",
  "block.minecraft.banner.curly_border.orange": "Ornge burdur indentd",
  "block.minecraft.banner.curly_border.pink": "Pink burdur indentd",
  "block.minecraft.banner.curly_border.purple": "Purpal burdur indentd",
  "block.minecraft.banner.curly_border.red": "Red burdur indentd",
  "block.minecraft.banner.curly_border.white": "Wite burdur indentd",
  "block.minecraft.banner.curly_border.yellow": "Yello burdur indentd",
  "block.minecraft.banner.diagonal_left.black": "Blak Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.blue": "Blu Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.brown": "Browhn Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.cyan": "Sigh-Ann Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.gray": "Grey Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.green": "Grean Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.light_blue": "Lite Blu Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.light_gray": "Lite Grey Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.lime": "Lah-I'm Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.magenta": "Muhgentuh Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.orange": "Ohrang Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.pink": "Pink Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.purple": "Purpel Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.red": "Red Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.white": "Wite Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_left.yellow": "Yelo Pr Behnd Sinistar",
  "block.minecraft.banner.diagonal_right.black": "Blak Purr Bend",
  "block.minecraft.banner.diagonal_right.blue": "Bloo Purr Bend",
  "block.minecraft.banner.diagonal_right.brown": "Brwn Purr Bend",
  "block.minecraft.banner.diagonal_right.cyan": "Sighan Purr Bend",
  "block.minecraft.banner.diagonal_right.gray": "Gra Purr Bend",
  "block.minecraft.banner.diagonal_right.green": "Gren Purr Bend",
  "block.minecraft.banner.diagonal_right.light_blue": "Lite Bloo Purr Bend",
  "block.minecraft.banner.diagonal_right.light_gray": "Lite Gra Purr Bend",
  "block.minecraft.banner.diagonal_right.lime": "Liem Purr Bend",
  "block.minecraft.banner.diagonal_right.magenta": "Majentaa Purr Bend",
  "block.minecraft.banner.diagonal_right.orange": "Ornge Purr Bend",
  "block.minecraft.banner.diagonal_right.pink": "Pnk Purr Bend",
  "block.minecraft.banner.diagonal_right.purple": "Purrrrple Purr Bend",
  "block.minecraft.banner.diagonal_right.red": "Redd Purr Bend",
  "block.minecraft.banner.diagonal_right.white": "Wite Purr Bend",
  "block.minecraft.banner.diagonal_right.yellow": "Yelo Purr Bend",
  "block.minecraft.banner.diagonal_up_left.black": "Blak Pr Behnd Inverted",
  "block.minecraft.banner.diagonal_up_left.blue": "Blu Pr Behnd Inverted",
  "block.minecraft.banner.diagonal_up_left.brown": "Browwhn Pr Behnd Inverted",
  "block.minecraft.banner.diagonal_up_left.cyan": "Sigh-Ann Pr Behnd Inverted",
  "block.minecraft.banner.diagonal_up_left.gray": "Gray Per Bend Invertd",
  "block.minecraft.banner.diagonal_up_left.green": "Grean Pr Behnd Inverted",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Light Blue Per Bend Invertd",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Lite Gra Purr Bend Invertd",
  "block.minecraft.banner.diagonal_up_left.lime": "Lime Per Bend Invertd",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Per Bend Invertd",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange Per Bend Invertd",
  "block.minecraft.banner.diagonal_up_left.pink": "Pink Per Bend Invertd",
  "block.minecraft.banner.diagonal_up_left.purple": "Perpul Pr Behnd Inverted",
  "block.minecraft.banner.diagonal_up_left.red": "Red Pr Behnd Inverted",
  "block.minecraft.banner.diagonal_up_left.white": "Wait Pur Bent Invertd",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow Per Bend Invertd",
  "block.minecraft.banner.diagonal_up_right.black": "Blak Par Bentsinistrrr Incetteerf",
  "block.minecraft.banner.diagonal_up_right.blue": "Bluu Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.brown": "Brown Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyan Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.gray": "Gry Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.green": "Gren Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Light bluu Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Light Gry Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.lime": "Laim Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magnta Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.orange": "Orang Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.pink": "Pink Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.purple": "Purpl Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.red": "Red Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.white": "Whit Pur Bed Sinster Invertud",
  "block.minecraft.banner.diagonal_up_right.yellow": "Yello Pur Bed Sinster Invertud",
  "block.minecraft.banner.flow.black": "Blak Flw",
  "block.minecraft.banner.flow.blue": "Bloo Flw",
  "block.minecraft.banner.flow.brown": "Brow Flw",
  "block.minecraft.banner.flow.cyan": "Sighun Flw",
  "block.minecraft.banner.flow.gray": "Grai Flw",
  "block.minecraft.banner.flow.green": "Gren Flw",
  "block.minecraft.banner.flow.light_blue": "Lite Bloo Flw",
  "block.minecraft.banner.flow.light_gray": "Lite Grai Flw",
  "block.minecraft.banner.flow.lime": "Limd Flw",
  "block.minecraft.banner.flow.magenta": "Majenta Flw",
  "block.minecraft.banner.flow.orange": "Ornge Flw",
  "block.minecraft.banner.flow.pink": "Pinky Flw",
  "block.minecraft.banner.flow.purple": "Parpal Flw",
  "block.minecraft.banner.flow.red": "Red Flw",
  "block.minecraft.banner.flow.white": "Waite Flw",
  "block.minecraft.banner.flow.yellow": "Yello Flw",
  "block.minecraft.banner.flower.black": "Blak flowr karge",
  "block.minecraft.banner.flower.blue": "Bloo Fluor Charg",
  "block.minecraft.banner.flower.brown": "Broun Fluor Charg",
  "block.minecraft.banner.flower.cyan": "Sighan Fluor Charg",
  "block.minecraft.banner.flower.gray": "Gra Fluor Charg",
  "block.minecraft.banner.flower.green": "Gren Fluor Charg",
  "block.minecraft.banner.flower.light_blue": "Lite Bloo Fluor Charg",
  "block.minecraft.banner.flower.light_gray": "Lite Gra Fluor Charg",
  "block.minecraft.banner.flower.lime": "Liem Fluor Charg",
  "block.minecraft.banner.flower.magenta": "Majentaa Fluor Charg",
  "block.minecraft.banner.flower.orange": "Orang Fluor Charg",
  "block.minecraft.banner.flower.pink": "Pinc Fluor Charg",
  "block.minecraft.banner.flower.purple": "Purrrpl Fluor Charg",
  "block.minecraft.banner.flower.red": "Redd Fluor Charg",
  "block.minecraft.banner.flower.white": "Wite Fluor Charg",
  "block.minecraft.banner.flower.yellow": "Yelo Fluor Charg",
  "block.minecraft.banner.globe.black": "Ender Glolbe",
  "block.minecraft.banner.globe.blue": "Water Glolbe",
  "block.minecraft.banner.globe.brown": "Chocolate Glolbe",
  "block.minecraft.banner.globe.cyan": "Cyaan Glolbe",
  "block.minecraft.banner.globe.gray": "Gray Glolbe",
  "block.minecraft.banner.globe.green": "Grass Glolbe",
  "block.minecraft.banner.globe.light_blue": "Waterer Glolbe",
  "block.minecraft.banner.globe.light_gray": "Lite Cyaan Glolbe",
  "block.minecraft.banner.globe.lime": "Limd Glolbe",
  "block.minecraft.banner.globe.magenta": "Majenta Glolbe",
  "block.minecraft.banner.globe.orange": "Carrot Glolbe",
  "block.minecraft.banner.globe.pink": "Pinky Glolbe",
  "block.minecraft.banner.globe.purple": "Parpal Glolbe",
  "block.minecraft.banner.globe.red": "Mojang Glolbe",
  "block.minecraft.banner.globe.white": "Snow Glolbe",
  "block.minecraft.banner.globe.yellow": "Banana Glolbe",
  "block.minecraft.banner.gradient.black": "bleck faed",
  "block.minecraft.banner.gradient.blue": "bleu faed",
  "block.minecraft.banner.gradient.brown": "brouwn faed",
  "block.minecraft.banner.gradient.cyan": "sea faed",
  "block.minecraft.banner.gradient.gray": "grey faed",
  "block.minecraft.banner.gradient.green": "greeen faed",
  "block.minecraft.banner.gradient.light_blue": "lit bru gradz",
  "block.minecraft.banner.gradient.light_gray": "lite grey faed",
  "block.minecraft.banner.gradient.lime": "liem faed",
  "block.minecraft.banner.gradient.magenta": "maginte gradz",
  "block.minecraft.banner.gradient.orange": "oranje gradz",
  "block.minecraft.banner.gradient.pink": "pienk faed",
  "block.minecraft.banner.gradient.purple": "TEH PRPLZ TRANSIST",
  "block.minecraft.banner.gradient.red": "ryd faed",
  "block.minecraft.banner.gradient.white": "wit gradz",
  "block.minecraft.banner.gradient.yellow": "yelouw faed",
  "block.minecraft.banner.gradient_up.black": "blk gradz",
  "block.minecraft.banner.gradient_up.blue": "bru gradz",
  "block.minecraft.banner.gradient_up.brown": "bruwn gradz",
  "block.minecraft.banner.gradient_up.cyan": "nyan gradz",
  "block.minecraft.banner.gradient_up.gray": "gra grade",
  "block.minecraft.banner.gradient_up.green": "gran gradz",
  "block.minecraft.banner.gradient_up.light_blue": "lite blu gradz",
  "block.minecraft.banner.gradient_up.light_gray": "lit gra grade",
  "block.minecraft.banner.gradient_up.lime": "lemi gradz",
  "block.minecraft.banner.gradient_up.magenta": "magintaz gradz",
  "block.minecraft.banner.gradient_up.orange": "Ohrang Baze Graidieant",
  "block.minecraft.banner.gradient_up.pink": "oink gradz",
  "block.minecraft.banner.gradient_up.purple": "poiple gradz",
  "block.minecraft.banner.gradient_up.red": "rad gradz",
  "block.minecraft.banner.gradient_up.white": "Wite Bas Gradeent",
  "block.minecraft.banner.gradient_up.yellow": "yello grad",
  "block.minecraft.banner.guster.black": "Blak Gusta",
  "block.minecraft.banner.guster.blue": "Bloo Gusta",
  "block.minecraft.banner.guster.brown": "Brow Gusta",
  "block.minecraft.banner.guster.cyan": "Sighun Gusta",
  "block.minecraft.banner.guster.gray": "Grai Gusta",
  "block.minecraft.banner.guster.green": "Greenish Gusta",
  "block.minecraft.banner.guster.light_blue": "Lite Bloo Gusta",
  "block.minecraft.banner.guster.light_gray": "Lite Grai Gusta",
  "block.minecraft.banner.guster.lime": "Limd Gusta",
  "block.minecraft.banner.guster.magenta": "Majenta Gusta",
  "block.minecraft.banner.guster.orange": "Ornge Gusta",
  "block.minecraft.banner.guster.pink": "Pinky Gusta",
  "block.minecraft.banner.guster.purple": "Parpal Gusta",
  "block.minecraft.banner.guster.red": "Redis Gusta",
  "block.minecraft.banner.guster.white": "Waite Gusta",
  "block.minecraft.banner.guster.yellow": "Yello Gusta",
  "block.minecraft.banner.half_horizontal.black": "blak purr fez",
  "block.minecraft.banner.half_horizontal.blue": "blu purr fez",
  "block.minecraft.banner.half_horizontal.brown": "brawn purr fez",
  "block.minecraft.banner.half_horizontal.cyan": "cian purr fez",
  "block.minecraft.banner.half_horizontal.gray": "grey perr fez",
  "block.minecraft.banner.half_horizontal.green": "grean purr fez",
  "block.minecraft.banner.half_horizontal.light_blue": "lightish blu perr fez",
  "block.minecraft.banner.half_horizontal.light_gray": "lightish grey purr fez",
  "block.minecraft.banner.half_horizontal.lime": "lime perr fez",
  "block.minecraft.banner.half_horizontal.magenta": "majenta perr fez",
  "block.minecraft.banner.half_horizontal.orange": "orange perr fez",
  "block.minecraft.banner.half_horizontal.pink": "pink perr fez",
  "block.minecraft.banner.half_horizontal.purple": "purrpel purr fez",
  "block.minecraft.banner.half_horizontal.red": "red purr fez",
  "block.minecraft.banner.half_horizontal.white": "colorless perr fez",
  "block.minecraft.banner.half_horizontal.yellow": "yello perr fez",
  "block.minecraft.banner.half_horizontal_bottom.black": "blak purr fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Bloo par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.brown": "brown purr fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Nyan par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grey par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.green": "green purr fess inverted",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Lite bloo par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Lite Gray par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Lyem par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Majenta par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Ornge par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Pink par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Purpal par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.red": "Red par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.white": "Wite par fazz invertud",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Yello par fazz invertud",
  "block.minecraft.banner.half_vertical.black": "blak pur payl",
  "block.minecraft.banner.half_vertical.blue": "bloo pore payl",
  "block.minecraft.banner.half_vertical.brown": "broun  pr payl",
  "block.minecraft.banner.half_vertical.cyan": "cian pur pal",
  "block.minecraft.banner.half_vertical.gray": "grey purr peil",
  "block.minecraft.banner.half_vertical.green": "grean por pail",
  "block.minecraft.banner.half_vertical.light_blue": "lightt bkuez purr pail",
  "block.minecraft.banner.half_vertical.light_gray": "lit gra pur pal",
  "block.minecraft.banner.half_vertical.lime": "leim purr peil",
  "block.minecraft.banner.half_vertical.magenta": "majenta purr pail",
  "block.minecraft.banner.half_vertical.orange": "oringe purr peil",
  "block.minecraft.banner.half_vertical.pink": "stylish purr peil",
  "block.minecraft.banner.half_vertical.purple": "porple pair paiyiyil",
  "block.minecraft.banner.half_vertical.red": "red par pal",
  "block.minecraft.banner.half_vertical.white": "white purr pail",
  "block.minecraft.banner.half_vertical.yellow": "yella purr peil",
  "block.minecraft.banner.half_vertical_right.black": "blak purr pale inverted",
  "block.minecraft.banner.half_vertical_right.blue": "blu purr pale inverted",
  "block.minecraft.banner.half_vertical_right.brown": "brown purr pale inverted",
  "block.minecraft.banner.half_vertical_right.cyan": "cyan purr pale inverted",
  "block.minecraft.banner.half_vertical_right.gray": "grey purr pale inverted",
  "block.minecraft.banner.half_vertical_right.green": "green purr pale inverted",
  "block.minecraft.banner.half_vertical_right.light_blue": "lightish blu purr pale inverted",
  "block.minecraft.banner.half_vertical_right.light_gray": "lighish grey purr pale inverted",
  "block.minecraft.banner.half_vertical_right.lime": "lime purr pale inverted",
  "block.minecraft.banner.half_vertical_right.magenta": "majenta purr pale inverted",
  "block.minecraft.banner.half_vertical_right.orange": "orange purr pale inverted",
  "block.minecraft.banner.half_vertical_right.pink": "pink purr pale inverted",
  "block.minecraft.banner.half_vertical_right.purple": "purrrppple purr pale inverted",
  "block.minecraft.banner.half_vertical_right.red": "red purr pale inverted",
  "block.minecraft.banner.half_vertical_right.white": "colorless purr pale inverted",
  "block.minecraft.banner.half_vertical_right.yellow": "yellow purr pale inverted",
  "block.minecraft.banner.mojang.black": "Blak thng",
  "block.minecraft.banner.mojang.blue": "Bloo thng",
  "block.minecraft.banner.mojang.brown": "Broun thng",
  "block.minecraft.banner.mojang.cyan": "Nyan thng",
  "block.minecraft.banner.mojang.gray": "Grey thng",
  "block.minecraft.banner.mojang.green": "Grean thng",
  "block.minecraft.banner.mojang.light_blue": "Lite bloo thng",
  "block.minecraft.banner.mojang.light_gray": "Lite Grey thng",
  "block.minecraft.banner.mojang.lime": "Lyme thng",
  "block.minecraft.banner.mojang.magenta": "Majenta thng",
  "block.minecraft.banner.mojang.orange": "Ornge thng",
  "block.minecraft.banner.mojang.pink": "Pig-colored thing",
  "block.minecraft.banner.mojang.purple": "Purpal thng",
  "block.minecraft.banner.mojang.red": "Redz thng",
  "block.minecraft.banner.mojang.white": "Wite thng",
  "block.minecraft.banner.mojang.yellow": "Yello thng",
  "block.minecraft.banner.piglin.black": "Blak noze",
  "block.minecraft.banner.piglin.blue": "Blu nouze",
  "block.minecraft.banner.piglin.brown": "Brown noze",
  "block.minecraft.banner.piglin.cyan": "Nyan noze",
  "block.minecraft.banner.piglin.gray": "Gray noze",
  "block.minecraft.banner.piglin.green": "Green noze",
  "block.minecraft.banner.piglin.light_blue": "Lite bluu nouze",
  "block.minecraft.banner.piglin.light_gray": "Lite gray noze",
  "block.minecraft.banner.piglin.lime": "Limy nose",
  "block.minecraft.banner.piglin.magenta": "Magenta nouze",
  "block.minecraft.banner.piglin.orange": "Oreng noze",
  "block.minecraft.banner.piglin.pink": "Pinku noze",
  "block.minecraft.banner.piglin.purple": "Purrpl noze",
  "block.minecraft.banner.piglin.red": "Redz noze",
  "block.minecraft.banner.piglin.white": "Wite noze",
  "block.minecraft.banner.piglin.yellow": "Yelo Noz",
  "block.minecraft.banner.rhombus.black": "blak losng",
  "block.minecraft.banner.rhombus.blue": "Blu losung",
  "block.minecraft.banner.rhombus.brown": "broun lozeng",
  "block.minecraft.banner.rhombus.cyan": "cian lozene",
  "block.minecraft.banner.rhombus.gray": "grey lozunj",
  "block.minecraft.banner.rhombus.green": "greyn lozinge",
  "block.minecraft.banner.rhombus.light_blue": "lit blu lozenge",
  "block.minecraft.banner.rhombus.light_gray": "lite gruy losinge",
  "block.minecraft.banner.rhombus.lime": "lym LOLzenge",
  "block.minecraft.banner.rhombus.magenta": "majina lizange",
  "block.minecraft.banner.rhombus.orange": "urang lizangee",
  "block.minecraft.banner.rhombus.pink": "Pinc Loseng",
  "block.minecraft.banner.rhombus.purple": "pupell losenge",
  "block.minecraft.banner.rhombus.red": "Rud lozanj",
  "block.minecraft.banner.rhombus.white": "wyte lozunge",
  "block.minecraft.banner.rhombus.yellow": "yullo lozunge",
  "block.minecraft.banner.skull.black": "Blac Scul Charg",
  "block.minecraft.banner.skull.blue": "Bloo Scul Charg",
  "block.minecraft.banner.skull.brown": "Broun Scul Charg",
  "block.minecraft.banner.skull.cyan": "Sighan Scul Charg",
  "block.minecraft.banner.skull.gray": "Gra Scul Charg",
  "block.minecraft.banner.skull.green": "Gren Scul Charg",
  "block.minecraft.banner.skull.light_blue": "Lite Bloo Scul Charg",
  "block.minecraft.banner.skull.light_gray": "Lite Gra Scul Charg",
  "block.minecraft.banner.skull.lime": "Liem Scul Charg",
  "block.minecraft.banner.skull.magenta": "Majentaa Scul Charg",
  "block.minecraft.banner.skull.orange": "Orang Scul Charg",
  "block.minecraft.banner.skull.pink": "Pinc Scul Charg",
  "block.minecraft.banner.skull.purple": "Purrrpl Scul Charg",
  "block.minecraft.banner.skull.red": "rad SKULLZ charg",
  "block.minecraft.banner.skull.white": "Wite Scul Charg",
  "block.minecraft.banner.skull.yellow": "Yelo Scul Charg",
  "block.minecraft.banner.small_stripes.black": "Blak Palee",
  "block.minecraft.banner.small_stripes.blue": "Bluu Palee",
  "block.minecraft.banner.small_stripes.brown": "Brawn Palee",
  "block.minecraft.banner.small_stripes.cyan": "CyN Palee",
  "block.minecraft.banner.small_stripes.gray": "Grey Palee",
  "block.minecraft.banner.small_stripes.green": "Gre-n Palee",
  "block.minecraft.banner.small_stripes.light_blue": "Lite Bloo Palee",
  "block.minecraft.banner.small_stripes.light_gray": "Light Grey Palee",
  "block.minecraft.banner.small_stripes.lime": "Limeh Palee",
  "block.minecraft.banner.small_stripes.magenta": "Mujentaa Palee",
  "block.minecraft.banner.small_stripes.orange": "Ornge Palee",
  "block.minecraft.banner.small_stripes.pink": "Pinky Palee",
  "block.minecraft.banner.small_stripes.purple": "PurpL Palee",
  "block.minecraft.banner.small_stripes.red": "Red Palee",
  "block.minecraft.banner.small_stripes.white": "Wyt Palee",
  "block.minecraft.banner.small_stripes.yellow": "Yelo Palee",
  "block.minecraft.banner.square_bottom_left.black": "Black Base Dextr Canton",
  "block.minecraft.banner.square_bottom_left.blue": "bluz bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.brown": "browzn bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.cyan": "sian bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.gray": "grae bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.green": "Green Base Dextr Canton",
  "block.minecraft.banner.square_bottom_left.light_blue": "lite blu bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.light_gray": "lite grae bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.lime": "laim bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.magenta": "majnta bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.orange": "oranj bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.pink": "pinkz bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.purple": "purpul bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.red": "Red Base Dextr Canton",
  "block.minecraft.banner.square_bottom_left.white": "wiit bais lepht skuair",
  "block.minecraft.banner.square_bottom_left.yellow": "yeloe bais lepht skuair",
  "block.minecraft.banner.square_bottom_right.black": "blak bais rite skuair",
  "block.minecraft.banner.square_bottom_right.blue": "blu bais rite skuair",
  "block.minecraft.banner.square_bottom_right.brown": "braun bais rite skuair",
  "block.minecraft.banner.square_bottom_right.cyan": "sian bais rite skuair",
  "block.minecraft.banner.square_bottom_right.gray": "grai bais rite skuair",
  "block.minecraft.banner.square_bottom_right.green": "grin bais rite skuair",
  "block.minecraft.banner.square_bottom_right.light_blue": "lite blu bais rite skuair",
  "block.minecraft.banner.square_bottom_right.light_gray": "lite grai bais rite skuair",
  "block.minecraft.banner.square_bottom_right.lime": "laim bais rite skuair",
  "block.minecraft.banner.square_bottom_right.magenta": "majnta bais rite skuair",
  "block.minecraft.banner.square_bottom_right.orange": "oraje bais rite skuair",
  "block.minecraft.banner.square_bottom_right.pink": "pinck bais rite skuair",
  "block.minecraft.banner.square_bottom_right.purple": "purpul bais rite skuair",
  "block.minecraft.banner.square_bottom_right.red": "red bais rite skuair",
  "block.minecraft.banner.square_bottom_right.white": "White baze sinistor kattun",
  "block.minecraft.banner.square_bottom_right.yellow": "yelloe bais rite skuair",
  "block.minecraft.banner.square_top_left.black": "blak cheef dextor kattun",
  "block.minecraft.banner.square_top_left.blue": "blooh cheef dextor cantun",
  "block.minecraft.banner.square_top_left.brown": "broawn cheef dextor kattun",
  "block.minecraft.banner.square_top_left.cyan": "cian cheef dextor cantun",
  "block.minecraft.banner.square_top_left.gray": "greh cheef dextor cantun",
  "block.minecraft.banner.square_top_left.green": "grein cheef dextor kattun",
  "block.minecraft.banner.square_top_left.light_blue": "liat blooh cheef dextor cantun",
  "block.minecraft.banner.square_top_left.light_gray": "liat greh cheef dextor cantun",
  "block.minecraft.banner.square_top_left.lime": "liame cheef dextor cantun",
  "block.minecraft.banner.square_top_left.magenta": "magentorh cheef dextor cantun",
  "block.minecraft.banner.square_top_left.orange": "oringe cheef dextor cantun",
  "block.minecraft.banner.square_top_left.pink": "piank cheef dextor cantun",
  "block.minecraft.banner.square_top_left.purple": "perpol cheef dextor cantun",
  "block.minecraft.banner.square_top_left.red": "red cheef dextor kattun",
  "block.minecraft.banner.square_top_left.white": "white cheef dextor cantun",
  "block.minecraft.banner.square_top_left.yellow": "yelow cheef dextor cantun",
  "block.minecraft.banner.square_top_right.black": "black cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.blue": "blooh cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.brown": "broawn cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.cyan": "cian cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.gray": "greyh cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.green": "grein cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.light_blue": "liat bloo cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.light_gray": "liat greyh cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.lime": "liame cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.magenta": "magentorh cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.orange": "oringe cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.pink": "piank cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.purple": "perpol cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.red": "red cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.white": "white cheef sinistor cantun",
  "block.minecraft.banner.square_top_right.yellow": "yelow cheef sinistor cantun",
  "block.minecraft.banner.straight_cross.black": "Blk Croz",
  "block.minecraft.banner.straight_cross.blue": "Bleu Croz",
  "block.minecraft.banner.straight_cross.brown": "Brawn Croz",
  "block.minecraft.banner.straight_cross.cyan": "Nyan Croz",
  "block.minecraft.banner.straight_cross.gray": "Grai Croz",
  "block.minecraft.banner.straight_cross.green": "Grean Croz",
  "block.minecraft.banner.straight_cross.light_blue": "Zero Bleu Croz",
  "block.minecraft.banner.straight_cross.light_gray": "Zero Grai Croz",
  "block.minecraft.banner.straight_cross.lime": "Lame Croz",
  "block.minecraft.banner.straight_cross.magenta": "Magnet Croz",
  "block.minecraft.banner.straight_cross.orange": "Orang-Utan Croz",
  "block.minecraft.banner.straight_cross.pink": "Pink Panther Croz",
  "block.minecraft.banner.straight_cross.purple": "Poople Croz",
  "block.minecraft.banner.straight_cross.red": "Read Croz",
  "block.minecraft.banner.straight_cross.white": "No Color Croz",
  "block.minecraft.banner.straight_cross.yellow": "Hello Yellow Croz",
  "block.minecraft.banner.stripe_bottom.black": "Blak Baze",
  "block.minecraft.banner.stripe_bottom.blue": "Bloo Baze",
  "block.minecraft.banner.stripe_bottom.brown": "Brwn Baze",
  "block.minecraft.banner.stripe_bottom.cyan": "Nyan Baze",
  "block.minecraft.banner.stripe_bottom.gray": "Gray Baze",
  "block.minecraft.banner.stripe_bottom.green": "Gren Baze",
  "block.minecraft.banner.stripe_bottom.light_blue": "Lite Bloo Baze",
  "block.minecraft.banner.stripe_bottom.light_gray": "Lite Gray Baze",
  "block.minecraft.banner.stripe_bottom.lime": "Liem Baze",
  "block.minecraft.banner.stripe_bottom.magenta": "Majenta Baze",
  "block.minecraft.banner.stripe_bottom.orange": "Orang Baze",
  "block.minecraft.banner.stripe_bottom.pink": "Pinc Baze",
  "block.minecraft.banner.stripe_bottom.purple": "Purpal Baze",
  "block.minecraft.banner.stripe_bottom.red": "Red Baze",
  "block.minecraft.banner.stripe_bottom.white": "Wite Baze",
  "block.minecraft.banner.stripe_bottom.yellow": "Yello Baze",
  "block.minecraft.banner.stripe_center.black": "Blak Pal",
  "block.minecraft.banner.stripe_center.blue": "Bloo Pal",
  "block.minecraft.banner.stripe_center.brown": "Brwn Pal",
  "block.minecraft.banner.stripe_center.cyan": "Sigh-an Pal",
  "block.minecraft.banner.stripe_center.gray": "Gra Pal",
  "block.minecraft.banner.stripe_center.green": "Gren Pal",
  "block.minecraft.banner.stripe_center.light_blue": "Lite Bloo Pal",
  "block.minecraft.banner.stripe_center.light_gray": "Lite Gra Pal",
  "block.minecraft.banner.stripe_center.lime": "Liem Pal",
  "block.minecraft.banner.stripe_center.magenta": "Majentaa Pal",
  "block.minecraft.banner.stripe_center.orange": "Ornge Pal",
  "block.minecraft.banner.stripe_center.pink": "Pinc Pal",
  "block.minecraft.banner.stripe_center.purple": "Purrrrrrple Pal",
  "block.minecraft.banner.stripe_center.red": "Red Pal\n",
  "block.minecraft.banner.stripe_center.white": "Wite Pal",
  "block.minecraft.banner.stripe_center.yellow": "Ylw Pal",
  "block.minecraft.banner.stripe_downleft.black": "Bluk Vend Sinizturr",
  "block.minecraft.banner.stripe_downleft.blue": "Bluu Bend SinistR",
  "block.minecraft.banner.stripe_downleft.brown": "Brahwn Bend SinistR",
  "block.minecraft.banner.stripe_downleft.cyan": "CyN Bend SinistR",
  "block.minecraft.banner.stripe_downleft.gray": "Grey Bend SinistR",
  "block.minecraft.banner.stripe_downleft.green": "Gren Bent Siniste",
  "block.minecraft.banner.stripe_downleft.light_blue": "Light Bluu Bend SinistR",
  "block.minecraft.banner.stripe_downleft.light_gray": "Light Grey Bend SinistR",
  "block.minecraft.banner.stripe_downleft.lime": "Limeh Bend SinistR",
  "block.minecraft.banner.stripe_downleft.magenta": "Magentah Bend SinistR",
  "block.minecraft.banner.stripe_downleft.orange": "Oreng Bend SinistR",
  "block.minecraft.banner.stripe_downleft.pink": "Pink Bend SinistR",
  "block.minecraft.banner.stripe_downleft.purple": "PurpL Bend SinistR",
  "block.minecraft.banner.stripe_downleft.red": "Reed Baend Sinistier",
  "block.minecraft.banner.stripe_downleft.white": "Wite Bend SinistR",
  "block.minecraft.banner.stripe_downleft.yellow": "Yolo-w Bend SinistR",
  "block.minecraft.banner.stripe_downright.black": "darrk dawn line",
  "block.minecraft.banner.stripe_downright.blue": "Bloo Bend",
  "block.minecraft.banner.stripe_downright.brown": "bruwn side line",
  "block.minecraft.banner.stripe_downright.cyan": "greeen bleu side line",
  "block.minecraft.banner.stripe_downright.gray": "greay side line",
  "block.minecraft.banner.stripe_downright.green": "greeen side line",
  "block.minecraft.banner.stripe_downright.light_blue": "Teh lite blu bend",
  "block.minecraft.banner.stripe_downright.light_gray": "wite greay side line",
  "block.minecraft.banner.stripe_downright.lime": "brite greeen side line",
  "block.minecraft.banner.stripe_downright.magenta": "Teh Magentra Bend",
  "block.minecraft.banner.stripe_downright.orange": "orng bend",
  "block.minecraft.banner.stripe_downright.pink": "peenk side line",
  "block.minecraft.banner.stripe_downright.purple": "Purrrrple Bend",
  "block.minecraft.banner.stripe_downright.red": "red dawn line",
  "block.minecraft.banner.stripe_downright.white": "Whit Bund",
  "block.minecraft.banner.stripe_downright.yellow": "yelaw side line",
  "block.minecraft.banner.stripe_left.black": "blak pail deztr",
  "block.minecraft.banner.stripe_left.blue": "blu pail deztr",
  "block.minecraft.banner.stripe_left.brown": "braun pail deztr",
  "block.minecraft.banner.stripe_left.cyan": "sian pail deztr",
  "block.minecraft.banner.stripe_left.gray": "grei pail deztr",
  "block.minecraft.banner.stripe_left.green": "grin pail deztr",
  "block.minecraft.banner.stripe_left.light_blue": "Lite Bleu Pail Dextr",
  "block.minecraft.banner.stripe_left.light_gray": "lite grei pail deztr",
  "block.minecraft.banner.stripe_left.lime": "laim pail deztr",
  "block.minecraft.banner.stripe_left.magenta": "Maginta Pail Dextr",
  "block.minecraft.banner.stripe_left.orange": "Orenge Pail Dextr",
  "block.minecraft.banner.stripe_left.pink": "pinck pail deztr",
  "block.minecraft.banner.stripe_left.purple": "purpl pail deztr",
  "block.minecraft.banner.stripe_left.red": "rad pail deztr",
  "block.minecraft.banner.stripe_left.white": "Wite Pail Dextr",
  "block.minecraft.banner.stripe_left.yellow": "Yello Pail Dextr",
  "block.minecraft.banner.stripe_middle.black": "Blak Fezz",
  "block.minecraft.banner.stripe_middle.blue": "Bloo Fezz",
  "block.minecraft.banner.stripe_middle.brown": "Brwn Fezz",
  "block.minecraft.banner.stripe_middle.cyan": "Sigh-an Fezz",
  "block.minecraft.banner.stripe_middle.gray": "Gray Fezz",
  "block.minecraft.banner.stripe_middle.green": "Gren Fezz",
  "block.minecraft.banner.stripe_middle.light_blue": "Late Bluu Fezz",
  "block.minecraft.banner.stripe_middle.light_gray": "Lite Gray Fezz",
  "block.minecraft.banner.stripe_middle.lime": "Lame Fezz",
  "block.minecraft.banner.stripe_middle.magenta": "purpl-ey Fezz",
  "block.minecraft.banner.stripe_middle.orange": "oranj dawn Fezz",
  "block.minecraft.banner.stripe_middle.pink": "Pinc Fezz",
  "block.minecraft.banner.stripe_middle.purple": "Purrrrple Fezz",
  "block.minecraft.banner.stripe_middle.red": "Red Fezz",
  "block.minecraft.banner.stripe_middle.white": "blanck dawn Fezz",
  "block.minecraft.banner.stripe_middle.yellow": "Yellau Fezz",
  "block.minecraft.banner.stripe_right.black": "Blak Peil Sinizter",
  "block.minecraft.banner.stripe_right.blue": "Bluu Peil Sinizter",
  "block.minecraft.banner.stripe_right.brown": "Braun Peil Sinizter",
  "block.minecraft.banner.stripe_right.cyan": "Cya Peil Sinizter",
  "block.minecraft.banner.stripe_right.gray": "Grayz Peil Sinizter",
  "block.minecraft.banner.stripe_right.green": "Gren Peil Sinizter",
  "block.minecraft.banner.stripe_right.light_blue": "Late Bluu Peil Sinizter",
  "block.minecraft.banner.stripe_right.light_gray": "Light Grayz Peil Sinizter",
  "block.minecraft.banner.stripe_right.lime": "Lame Peil Sinizter",
  "block.minecraft.banner.stripe_right.magenta": "Meigent Peil Sinizter",
  "block.minecraft.banner.stripe_right.orange": "Oreng Peil Sinizter",
  "block.minecraft.banner.stripe_right.pink": "Pink Peil Sinizter",
  "block.minecraft.banner.stripe_right.purple": "Purpl Peil Sinizter",
  "block.minecraft.banner.stripe_right.red": "Red Peil Sinizter",
  "block.minecraft.banner.stripe_right.white": "Wait Peil Sinizter",
  "block.minecraft.banner.stripe_right.yellow": "Yellau Peil Sinizter",
  "block.minecraft.banner.stripe_top.black": "Blak Chif",
  "block.minecraft.banner.stripe_top.blue": "Bloo Chif",
  "block.minecraft.banner.stripe_top.brown": "Brwn Chif",
  "block.minecraft.banner.stripe_top.cyan": "Nyan Chif",
  "block.minecraft.banner.stripe_top.gray": "Gray Chif",
  "block.minecraft.banner.stripe_top.green": "Gren Chif",
  "block.minecraft.banner.stripe_top.light_blue": "Lite Bloo Chif",
  "block.minecraft.banner.stripe_top.light_gray": "Lite Gray Chif",
  "block.minecraft.banner.stripe_top.lime": "Liem Chif",
  "block.minecraft.banner.stripe_top.magenta": "Majenta Chif",
  "block.minecraft.banner.stripe_top.orange": "Orang Chif",
  "block.minecraft.banner.stripe_top.pink": "Pinc Chif",
  "block.minecraft.banner.stripe_top.purple": "Parpal Chif",
  "block.minecraft.banner.stripe_top.red": "Redish Chif",
  "block.minecraft.banner.stripe_top.white": "Wite Chif",
  "block.minecraft.banner.stripe_top.yellow": "Yello Chif",
  "block.minecraft.banner.triangle_bottom.black": "Dark Chevronz",
  "block.minecraft.banner.triangle_bottom.blue": "Blu Chevronz",
  "block.minecraft.banner.triangle_bottom.brown": "Brown Chevronz",
  "block.minecraft.banner.triangle_bottom.cyan": "Sighan Shevrun",
  "block.minecraft.banner.triangle_bottom.gray": "GREY SHEVRON",
  "block.minecraft.banner.triangle_bottom.green": "Green Chevronz",
  "block.minecraft.banner.triangle_bottom.light_blue": "Lite Bloo Shevrun",
  "block.minecraft.banner.triangle_bottom.light_gray": "VERY LITE GREY SHEVRON",
  "block.minecraft.banner.triangle_bottom.lime": "Liem Shevrun",
  "block.minecraft.banner.triangle_bottom.magenta": "Majentaa Shevrun",
  "block.minecraft.banner.triangle_bottom.orange": "Orung Shevrun",
  "block.minecraft.banner.triangle_bottom.pink": "PIINK SHEVRON",
  "block.minecraft.banner.triangle_bottom.purple": "PRPLZ CHVRN",
  "block.minecraft.banner.triangle_bottom.red": "Red Chevronz",
  "block.minecraft.banner.triangle_bottom.white": "Wite Shevrun",
  "block.minecraft.banner.triangle_bottom.yellow": "Yelo Shevrun",
  "block.minecraft.banner.triangle_top.black": "blakc upsied v",
  "block.minecraft.banner.triangle_top.blue": "blew upsied v",
  "block.minecraft.banner.triangle_top.brown": "broun upsied v",
  "block.minecraft.banner.triangle_top.cyan": "bleuy upsied v",
  "block.minecraft.banner.triangle_top.gray": "grey upsied v",
  "block.minecraft.banner.triangle_top.green": "grn upsied v",
  "block.minecraft.banner.triangle_top.light_blue": "lite blew upsied v",
  "block.minecraft.banner.triangle_top.light_gray": "lite grey upsied v",
  "block.minecraft.banner.triangle_top.lime": "liem upsied v",
  "block.minecraft.banner.triangle_top.magenta": "puerple upsied v",
  "block.minecraft.banner.triangle_top.orange": "orangue upsied v",
  "block.minecraft.banner.triangle_top.pink": "pienk upsied v",
  "block.minecraft.banner.triangle_top.purple": "purrple upsied v",
  "block.minecraft.banner.triangle_top.red": "ryd upsied v",
  "block.minecraft.banner.triangle_top.white": "whiet upsied v",
  "block.minecraft.banner.triangle_top.yellow": "yelou upsied v",
  "block.minecraft.banner.triangles_bottom.black": "bleck bottum indiented",
  "block.minecraft.banner.triangles_bottom.blue": "bleu bottum indiented",
  "block.minecraft.banner.triangles_bottom.brown": "broun bottum indiented",
  "block.minecraft.banner.triangles_bottom.cyan": "cian bottum indiented",
  "block.minecraft.banner.triangles_bottom.gray": "grey bottum indiented",
  "block.minecraft.banner.triangles_bottom.green": "greun bottum indiented",
  "block.minecraft.banner.triangles_bottom.light_blue": "lite bleu bottum indiented",
  "block.minecraft.banner.triangles_bottom.light_gray": "lite grey bottum indiented",
  "block.minecraft.banner.triangles_bottom.lime": "liem bottum indiented",
  "block.minecraft.banner.triangles_bottom.magenta": "prple bottum indiented",
  "block.minecraft.banner.triangles_bottom.orange": "oraynge bottum indiented",
  "block.minecraft.banner.triangles_bottom.pink": "pienk bottum indiented",
  "block.minecraft.banner.triangles_bottom.purple": "pyrple bottum indiented",
  "block.minecraft.banner.triangles_bottom.red": "read bottum indiented",
  "block.minecraft.banner.triangles_bottom.white": "whiet bottum indiented",
  "block.minecraft.banner.triangles_bottom.yellow": "YELLOU BASS INDEZTED",
  "block.minecraft.banner.triangles_top.black": "BLAWK CHEEF INDEZTED",
  "block.minecraft.banner.triangles_top.blue": "Bwue Cheef Indentd",
  "block.minecraft.banner.triangles_top.brown": "Bwown Cheef Indentd",
  "block.minecraft.banner.triangles_top.cyan": "Cian Cheef Indentd",
  "block.minecraft.banner.triangles_top.gray": "Gray Cheef Indentd",
  "block.minecraft.banner.triangles_top.green": "Gween Cheef Indentd",
  "block.minecraft.banner.triangles_top.light_blue": "Lite Blu Cheef Indentd",
  "block.minecraft.banner.triangles_top.light_gray": "Lit gray Cheef Indentd",
  "block.minecraft.banner.triangles_top.lime": "Laim Cheef Indentd",
  "block.minecraft.banner.triangles_top.magenta": "Mahgehntah Cheef Indentd",
  "block.minecraft.banner.triangles_top.orange": "Ohrang Cheef Indentd",
  "block.minecraft.banner.triangles_top.pink": "Pnik Cheef Indentd",
  "block.minecraft.banner.triangles_top.purple": "Purrrple Cheef Indentd",
  "block.minecraft.banner.triangles_top.red": "Red Cheef Indentd",
  "block.minecraft.banner.triangles_top.white": "Wuhite Cheef Indentd",
  "block.minecraft.banner.triangles_top.yellow": "Yallo Cheef Indentd",
  "block.minecraft.barrel": "Fish box",
  "block.minecraft.barrier": "You shall not pass",
  "block.minecraft.basalt": "Bawzult",
  "block.minecraft.beacon": "Bacon",
  "block.minecraft.beacon.primary": "Primari Pahwer",
  "block.minecraft.beacon.secondary": "Secondari Pahwer",
  "block.minecraft.bed.no_sleep": "U can shleep onwy at nite and duwin thundewstuwms",
  "block.minecraft.bed.not_safe": "U do not haf tu rezt nao; der are monztahrs nirby",
  "block.minecraft.bed.obstructed": "Dis bed iz obstructd",
  "block.minecraft.bed.occupied": "Sumone stole ur bed!",
  "block.minecraft.bed.too_far_away": "U do not haf tu rezt nao; da bed is TOO FAR awey",
  "block.minecraft.bedrock": "TROL BLUKZ",
  "block.minecraft.bee_nest": "B nest",
  "block.minecraft.beehive": "Beez's place",
  "block.minecraft.beetroots": "Red Juicy Undrgrawnd Plant",
  "block.minecraft.bell": "Belly",
  "block.minecraft.big_dripleaf": "Big fall thru plantt",
  "block.minecraft.big_dripleaf_stem": "Big fall thru plantt stehm",
  "block.minecraft.birch_button": "Burch Button",
  "block.minecraft.birch_door": "Burch Dor",
  "block.minecraft.birch_fence": "BIRCH SCRATCHEZPOST",
  "block.minecraft.birch_fence_gate": "BURCH GAIT",
  "block.minecraft.birch_hanging_sign": "Burchs Danglin' Sign",
  "block.minecraft.birch_leaves": "birch salad",
  "block.minecraft.birch_log": "lite woodezn lawg",
  "block.minecraft.birch_planks": "lite woodezn blox",
  "block.minecraft.birch_pressure_plate": "Burch Prseure Pleitz",
  "block.minecraft.birch_sapling": "baby burch",
  "block.minecraft.birch_shelf": "Burch Shelv",
  "block.minecraft.birch_sign": "Burchs Sign",
  "block.minecraft.birch_slab": "Burch Sleb",
  "block.minecraft.birch_stairs": "Burch Stairz",
  "block.minecraft.birch_trapdoor": "Burch Trap",
  "block.minecraft.birch_wall_hanging_sign": "Burchs Danglin' Sign On Da Wall",
  "block.minecraft.birch_wall_sign": "Burchs Sign on ur wall",
  "block.minecraft.birch_wood": "Brch Wud",
  "block.minecraft.black_banner": "blakc bahnor",
  "block.minecraft.black_bed": "Blak Bed",
  "block.minecraft.black_candle": "Blak land pikl",
  "block.minecraft.black_candle_cake": "Caek wif Blak Candl",
  "block.minecraft.black_carpet": "Black Cat Rug",
  "block.minecraft.black_concrete": "Blek tough bluk",
  "block.minecraft.black_concrete_powder": "Blak tough bluk powdr",
  "block.minecraft.black_glazed_terracotta": "Blek mosaic",
  "block.minecraft.black_shulker_box": "Black Shulker Bux",
  "block.minecraft.black_stained_glass": "Blak Staind Glas",
  "block.minecraft.black_stained_glass_pane": "blerk thin culurd thingy",
  "block.minecraft.black_terracotta": "Blak Teracottah",
  "block.minecraft.black_wool": "Blackish Fur Bluk",
  "block.minecraft.blackstone": "Blecston",
  "block.minecraft.blackstone_slab": "bleckston sleb",
  "block.minecraft.blackstone_stairs": "bleck rock stairz",
  "block.minecraft.blackstone_wall": "bleckston wal",
  "block.minecraft.blast_furnace": "BlAsT FuRnAcE",
  "block.minecraft.blue_banner": "bloo bahnor",
  "block.minecraft.blue_bed": "Bloo Bed",
  "block.minecraft.blue_candle": "Bloo hot stik",
  "block.minecraft.blue_candle_cake": "Caek wif Bloo Land pikl",
  "block.minecraft.blue_carpet": "Blu Cat Rug",
  "block.minecraft.blue_concrete": "Bluu tough bluk",
  "block.minecraft.blue_concrete_powder": "Bluu tough bluk powdr",
  "block.minecraft.blue_glazed_terracotta": "Bluu mosaic",
  "block.minecraft.blue_ice": "Big blu",
  "block.minecraft.blue_orchid": "pretteh bloo flowr",
  "block.minecraft.blue_shulker_box": "Bloo Shulker Bux",
  "block.minecraft.blue_stained_glass": "Waterly Stained Glazz",
  "block.minecraft.blue_stained_glass_pane": "Bloo Staned Glas Pan",
  "block.minecraft.blue_terracotta": "Bloo Terrakattah",
  "block.minecraft.blue_wool": "Bloo Fur Bluk",
  "block.minecraft.bone_block": "Compresd bone",
  "block.minecraft.bookshelf": "bed 4 bookz",
  "block.minecraft.brain_coral": "Brein koral",
  "block.minecraft.brain_coral_block": "Brein koral cube",
  "block.minecraft.brain_coral_fan": "Brein koral fen",
  "block.minecraft.brain_coral_wall_fan": "Braen Corel Wahll Fan",
  "block.minecraft.brewing_stand": "Bubbleh",
  "block.minecraft.brick_slab": "Brik Sleb",
  "block.minecraft.brick_stairs": "Brik stairez",
  "block.minecraft.brick_wall": "Brik Wal",
  "block.minecraft.bricks": "brickz",
  "block.minecraft.brown_banner": "broun bahnor",
  "block.minecraft.brown_bed": "Brownish Bed",
  "block.minecraft.brown_candle": "Brwn land pikl",
  "block.minecraft.brown_candle_cake": "Caek wif Brown Candl",
  "block.minecraft.brown_carpet": "Brownish Cat Rug",
  "block.minecraft.brown_concrete": "Brownish tough bluk",
  "block.minecraft.brown_concrete_powder": "Brownish tough bluk powdr",
  "block.minecraft.brown_glazed_terracotta": "Brownish mosaic",
  "block.minecraft.brown_mushroom": "brwn Mushroom",
  "block.minecraft.brown_mushroom_block": "brwn Mushroom Blok",
  "block.minecraft.brown_shulker_box": "Brownish Shulker Bux",
  "block.minecraft.brown_stained_glass": "Brownly Stainedly Glazz",
  "block.minecraft.brown_stained_glass_pane": "Broun Staned Glas Pan",
  "block.minecraft.brown_terracotta": "Brewn Terrakattah",
  "block.minecraft.brown_wool": "Brownish Fur Bluk",
  "block.minecraft.bubble_column": "babul kolum",
  "block.minecraft.bubble_coral": "Bubol koral",
  "block.minecraft.bubble_coral_block": "Bubol koral cube",
  "block.minecraft.bubble_coral_fan": "Bubol koral fen",
  "block.minecraft.bubble_coral_wall_fan": "Bable koral wull fan",
  "block.minecraft.budding_amethyst": "Purpur shinee makr",
  "block.minecraft.bush": "Smol tree",
  "block.minecraft.cactus": "Spiky Green Plant",
  "block.minecraft.cactus_flower": "Thornz flowah",
  "block.minecraft.cake": "liez",
  "block.minecraft.calcite": "Wite rok",
  "block.minecraft.calibrated_sculk_sensor": "smart catz Sculk detektor",
  "block.minecraft.campfire": "Campfireh",
  "block.minecraft.candle": "Land pikl",
  "block.minecraft.candle_cake": "lie wif hot stix",
  "block.minecraft.carrots": "i haz rabit fuds",
  "block.minecraft.cartography_table": "Cartogrophy Table",
  "block.minecraft.carved_pumpkin": "Karvd Pumpkin",
  "block.minecraft.cauldron": "Rly big pot",
  "block.minecraft.cave_air": "air of spOoOky cavess",
  "block.minecraft.cave_vines": "Caev wiskrs",
  "block.minecraft.cave_vines_plant": "Shinin' Viine Plantta o' Caevs",
  "block.minecraft.chain": "Shain",
  "block.minecraft.chain_command_block": "Alpha Block Dat Duz A Congo Line With Other Alpha Blocks",
  "block.minecraft.cherry_button": "Sakura Buttun",
  "block.minecraft.cherry_door": "Sakura dur",
  "block.minecraft.cherry_fence": "Sakura fence",
  "block.minecraft.cherry_fence_gate": "Sakura fenc gaet",
  "block.minecraft.cherry_hanging_sign": "Sakura Danglin' Sign",
  "block.minecraft.cherry_leaves": "Sakura lef",
  "block.minecraft.cherry_log": "Sakura lawg",
  "block.minecraft.cherry_planks": "Sakura plankz",
  "block.minecraft.cherry_pressure_plate": "Sakura Prseure Pleitz",
  "block.minecraft.cherry_sapling": "baby sakura",
  "block.minecraft.cherry_shelf": "Sakura Shelv",
  "block.minecraft.cherry_sign": "Sakura sign",
  "block.minecraft.cherry_slab": "Sakura sleb",
  "block.minecraft.cherry_stairs": "Sakura stairz",
  "block.minecraft.cherry_trapdoor": "Sakura trapdur",
  "block.minecraft.cherry_wall_hanging_sign": "Sakura Wall Danglin' Sign",
  "block.minecraft.cherry_wall_sign": "Sakura Sign On Da Wall",
  "block.minecraft.cherry_wood": "Sakura wuud",
  "block.minecraft.chest": "Cat Box",
  "block.minecraft.chipped_anvil": "Oh so much chipped anvehl",
  "block.minecraft.chiseled_bookshelf": "Hollow Bed 4 Books",
  "block.minecraft.chiseled_copper": "Pretteh Coper",
  "block.minecraft.chiseled_deepslate": "chizeled dark ston",
  "block.minecraft.chiseled_nether_bricks": "Chizald Nether Brickz",
  "block.minecraft.chiseled_polished_blackstone": "chizald shiny blak rok",
  "block.minecraft.chiseled_quartz_block": "Chizald Kworts Blak",
  "block.minecraft.chiseled_red_sandstone": "Chizald warmy sanstown",
  "block.minecraft.chiseled_resin_bricks": "Spooky yelo stiky brix",
  "block.minecraft.chiseled_sandstone": "carved litter box rockz",
  "block.minecraft.chiseled_stone_bricks": "Stacked Rockz en an Patternz",
  "block.minecraft.chiseled_tuff": "Pretteh Tff",
  "block.minecraft.chiseled_tuff_bricks": "Pretth Tff Rocz",
  "block.minecraft.chorus_flower": "Meow flawur",
  "block.minecraft.chorus_plant": "Meow Plantz",
  "block.minecraft.clay": "CLAE",
  "block.minecraft.closed_eyeblossom": "Sleepy eye flowah",
  "block.minecraft.coal_block": "Koala",
  "block.minecraft.coal_ore": "blak dusty rok",
  "block.minecraft.coarse_dirt": "Ruff durt",
  "block.minecraft.cobbled_deepslate": "coobled dark ston",
  "block.minecraft.cobbled_deepslate_slab": "coobled dark ston sleb",
  "block.minecraft.cobbled_deepslate_stairs": "coobled dark ston stairz",
  "block.minecraft.cobbled_deepslate_wall": "coobled dark ston wal",
  "block.minecraft.cobblestone": "Cooblestoneh",
  "block.minecraft.cobblestone_slab": "small pebble blok",
  "block.minecraft.cobblestone_stairs": "rok stairz",
  "block.minecraft.cobblestone_wall": "COBULSTOWN WALL",
  "block.minecraft.cobweb": "icky spider webz",
  "block.minecraft.cocoa": "dont feed dis to ur catz",
  "block.minecraft.command_block": "Cmnd Bloc",
  "block.minecraft.comparator": "Redstone thingy",
  "block.minecraft.composter": "Compostr",
  "block.minecraft.conduit": "strange box",
  "block.minecraft.copper_bars": "Copurr Jeil Bahz",
  "block.minecraft.copper_block": "Blok of copurr",
  "block.minecraft.copper_bulb": "Copurr Bob",
  "block.minecraft.copper_chain": "Copurr Shain",
  "block.minecraft.copper_chest": "Co-purr Bokz",
  "block.minecraft.copper_door": "Copurr Noor",
  "block.minecraft.copper_golem_statue": "Copurr Caty Scratchin Pozt",
  "block.minecraft.copper_grate": "Copurr wit Holz",
  "block.minecraft.copper_lantern": "Copurr Lanturn",
  "block.minecraft.copper_ore": "Copurr rok",
  "block.minecraft.copper_torch": "Gren burny stick",
  "block.minecraft.copper_trapdoor": "Copurr Trepnoor",
  "block.minecraft.copper_wall_torch": "Gren burny stick on teh wol",
  "block.minecraft.cornflower": "Unicornflowerpower",
  "block.minecraft.cracked_deepslate_bricks": "half brokn dark ston breekz",
  "block.minecraft.cracked_deepslate_tiles": "half brokn dark ston tilz",
  "block.minecraft.cracked_nether_bricks": "Crakd Nether Brickz",
  "block.minecraft.cracked_polished_blackstone_bricks": "craked polised bleck briks",
  "block.minecraft.cracked_stone_bricks": "Stacked Pebblez",
  "block.minecraft.crafter": "Majik Kraftin Mashin",
  "block.minecraft.crafting_table": "Krafting Tabal",
  "block.minecraft.creaking_heart": "Silly glowing lawg",
  "block.minecraft.creeper_head": "Creeper Hed",
  "block.minecraft.creeper_wall_head": "Creeper Wall Hed",
  "block.minecraft.crimson_button": "Crimzn Bawttn",
  "block.minecraft.crimson_door": "Krimzn Big Kat Door",
  "block.minecraft.crimson_fence": "Crimzn Fanse",
  "block.minecraft.crimson_fence_gate": "Crimzn Fenc Gaet",
  "block.minecraft.crimson_fungus": "Crimzn Foongis",
  "block.minecraft.crimson_hanging_sign": "Krimzn Danglin' Sign",
  "block.minecraft.crimson_hyphae": "Weerd red nethar plnat",
  "block.minecraft.crimson_nylium": "Crimzun Nyanium",
  "block.minecraft.crimson_planks": "Crimsun planmks",
  "block.minecraft.crimson_pressure_plate": "Crimson prseure Pleitz",
  "block.minecraft.crimson_roots": "Crimsun roots",
  "block.minecraft.crimson_shelf": "Crimzn Shelv",
  "block.minecraft.crimson_sign": "Krimzn Syne",
  "block.minecraft.crimson_slab": "Crimzn Sleb",
  "block.minecraft.crimson_stairs": "Crimzn Staez",
  "block.minecraft.crimson_stem": "Crimzn stim",
  "block.minecraft.crimson_trapdoor": "Crimzn Kat Door",
  "block.minecraft.crimson_wall_hanging_sign": "Krimzn Danglin' Sign On Da Wall",
  "block.minecraft.crimson_wall_sign": "Red walz sign",
  "block.minecraft.crying_obsidian": "sad hardest thing evar",
  "block.minecraft.cut_copper": "1000° kniv vs cuprr blok",
  "block.minecraft.cut_copper_slab": "Slised copurr sleb",
  "block.minecraft.cut_copper_stairs": "Slised copurr sters",
  "block.minecraft.cut_red_sandstone": "Warmy red sanstown",
  "block.minecraft.cut_red_sandstone_slab": "Cut warmy sansdstoen sleb",
  "block.minecraft.cut_sandstone": "Warmy sanstown",
  "block.minecraft.cut_sandstone_slab": "Cut sansdstoen sleb",
  "block.minecraft.cyan_banner": "nyan bahnor",
  "block.minecraft.cyan_bed": "Nyan Bed",
  "block.minecraft.cyan_candle": "C-an land pikl",
  "block.minecraft.cyan_candle_cake": "Caek wif Cyan Candle",
  "block.minecraft.cyan_carpet": "Sighun Cat Rug",
  "block.minecraft.cyan_concrete": "Syan tough bluk",
  "block.minecraft.cyan_concrete_powder": "Syan tough bluk powdr",
  "block.minecraft.cyan_glazed_terracotta": "Syan mosaic",
  "block.minecraft.cyan_shulker_box": "Weird Blu Shulker Bux",
  "block.minecraft.cyan_stained_glass": "Cyanled Stainely Glazz",
  "block.minecraft.cyan_stained_glass_pane": "Sian Staned Glas Pan",
  "block.minecraft.cyan_terracotta": "Nyan Teracottah",
  "block.minecraft.cyan_wool": "Sighun Fur Bluk",
  "block.minecraft.damaged_anvil": "Oh so much braken anvehl",
  "block.minecraft.dandelion": "Yello Flowah",
  "block.minecraft.dark_oak_button": "Blak Oke Button",
  "block.minecraft.dark_oak_door": "Blak Oke Dor",
  "block.minecraft.dark_oak_fence": "Drk Oak Fence",
  "block.minecraft.dark_oak_fence_gate": "DARK GAIT",
  "block.minecraft.dark_oak_hanging_sign": "Dark Ook Danglin' Sign",
  "block.minecraft.dark_oak_leaves": "derk ok lefs",
  "block.minecraft.dark_oak_log": "darkz oak lawg",
  "block.minecraft.dark_oak_planks": "Blac Oak blocz",
  "block.minecraft.dark_oak_pressure_plate": "Dark Oke Prseure Pleitz",
  "block.minecraft.dark_oak_sapling": "baby blak oak",
  "block.minecraft.dark_oak_shelf": "Blak Oke Shelv",
  "block.minecraft.dark_oak_sign": "Dak Ook Sign",
  "block.minecraft.dark_oak_slab": "Blak Oke Sleb",
  "block.minecraft.dark_oak_stairs": "Dakwoak Stairz",
  "block.minecraft.dark_oak_trapdoor": "Blak Oke Trap",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Ook Danglin' Sign On Da Wall",
  "block.minecraft.dark_oak_wall_sign": "Dak Ook Sign on ur wall",
  "block.minecraft.dark_oak_wood": "Blak Oke Wuud",
  "block.minecraft.dark_prismarine": "Dark Prizmarine",
  "block.minecraft.dark_prismarine_slab": "Dark Prizmarine Sleb",
  "block.minecraft.dark_prismarine_stairs": "Dark Prizmarine Stairz",
  "block.minecraft.daylight_detector": "light eater",
  "block.minecraft.dead_brain_coral": "Ded brein koral",
  "block.minecraft.dead_brain_coral_block": "Ded brain koral cube",
  "block.minecraft.dead_brain_coral_fan": "Ded brein koral fen",
  "block.minecraft.dead_brain_coral_wall_fan": "Ded brein koral wull fan",
  "block.minecraft.dead_bubble_coral": "Ded bubol koral",
  "block.minecraft.dead_bubble_coral_block": "Ded bubol koral cube",
  "block.minecraft.dead_bubble_coral_fan": "Ded bubol koral fen",
  "block.minecraft.dead_bubble_coral_wall_fan": "Ded bable korall wull fan",
  "block.minecraft.dead_bush": "Died bushez",
  "block.minecraft.dead_fire_coral": "Ded HOT koral",
  "block.minecraft.dead_fire_coral_block": "Ded HOT koral cube",
  "block.minecraft.dead_fire_coral_fan": "Ded HOT koral fen",
  "block.minecraft.dead_fire_coral_wall_fan": "Ded hot korall wull fan",
  "block.minecraft.dead_horn_coral": "Ded jorn koral",
  "block.minecraft.dead_horn_coral_block": "Ded jorn koral cube",
  "block.minecraft.dead_horn_coral_fan": "Ded jorn koral fen",
  "block.minecraft.dead_horn_coral_wall_fan": "Ded hurn korall wull fan",
  "block.minecraft.dead_tube_coral": "Ded tuf koral",
  "block.minecraft.dead_tube_coral_block": "Ded tuf koral cube",
  "block.minecraft.dead_tube_coral_fan": "Ded tuf koral fen",
  "block.minecraft.dead_tube_coral_wall_fan": "Ded tub koral wull fan",
  "block.minecraft.decorated_pot": "Ancient containr",
  "block.minecraft.deepslate": "dark ston",
  "block.minecraft.deepslate_brick_slab": "dark ston brik sleb",
  "block.minecraft.deepslate_brick_stairs": "dark ston brik stairz",
  "block.minecraft.deepslate_brick_wall": "dark ston brik wal",
  "block.minecraft.deepslate_bricks": "dark ston brikz",
  "block.minecraft.deepslate_coal_ore": "dark ston koal or",
  "block.minecraft.deepslate_copper_ore": "dark ston coppur or",
  "block.minecraft.deepslate_diamond_ore": "dark ston deemond or",
  "block.minecraft.deepslate_emerald_ore": "dark ston green shiny or",
  "block.minecraft.deepslate_gold_ore": "dark ston gold or",
  "block.minecraft.deepslate_iron_ore": "dark ston irony or",
  "block.minecraft.deepslate_lapis_ore": "dark ston bloo or",
  "block.minecraft.deepslate_redstone_ore": "dark ston Redstone or",
  "block.minecraft.deepslate_tile_slab": "dark ston til sleb",
  "block.minecraft.deepslate_tile_stairs": "dark ston til stairz",
  "block.minecraft.deepslate_tile_wall": "dark ston til wal",
  "block.minecraft.deepslate_tiles": "dark ston tilez",
  "block.minecraft.detector_rail": "Ditektar Ral",
  "block.minecraft.diamond_block": "MUCH MUNY $$$",
  "block.minecraft.diamond_ore": "Rockz wuth Dimundz",
  "block.minecraft.diorite": "kitteh litter rockz",
  "block.minecraft.diorite_slab": "Diorito Sleb",
  "block.minecraft.diorite_stairs": "Diorito Stairz",
  "block.minecraft.diorite_wall": "Diorito Wal",
  "block.minecraft.dirt": "Durt",
  "block.minecraft.dirt_path": "Durt roud",
  "block.minecraft.dispenser": "Dizpnzur",
  "block.minecraft.dragon_egg": "Dwagon Ec",
  "block.minecraft.dragon_head": "Dragun Hed",
  "block.minecraft.dragon_wall_head": "Dragon Wall Hed",
  "block.minecraft.dried_ghast": "Drid Ghast",
  "block.minecraft.dried_kelp_block": "Smoky lettuce cube",
  "block.minecraft.dripstone_block": "Dripstoen Blok",
  "block.minecraft.dropper": "DRUPPER",
  "block.minecraft.emerald_block": "Shineh bloock of Green stuff",
  "block.minecraft.emerald_ore": "Rockz wuth Emmiez",
  "block.minecraft.enchanting_table": "Kewl Tabel",
  "block.minecraft.end_gateway": "Megeek purrtul",
  "block.minecraft.end_portal": "Magik yarn bawl howl",
  "block.minecraft.end_portal_frame": "Magik portl fraem",
  "block.minecraft.end_rod": "Unikorn Horn",
  "block.minecraft.end_stone": "Weird white rock",
  "block.minecraft.end_stone_brick_slab": "Ston Brik Sleb of za End",
  "block.minecraft.end_stone_brick_stairs": "Ston Stairz of za End",
  "block.minecraft.end_stone_brick_wall": "Ston Brik Wal of za End",
  "block.minecraft.end_stone_bricks": "Kat Litter Briks",
  "block.minecraft.ender_chest": "Ender Cat Box",
  "block.minecraft.exposed_chiseled_copper": "Seen Pretteh Copur",
  "block.minecraft.exposed_copper": "Seen copurr",
  "block.minecraft.exposed_copper_bars": "Seen Copurr Jeil Bahz",
  "block.minecraft.exposed_copper_bulb": "Seen Copur Bob",
  "block.minecraft.exposed_copper_chain": "Seen Copurr Shain",
  "block.minecraft.exposed_copper_chest": "Seen Copurr Bokz",
  "block.minecraft.exposed_copper_door": "Seen Copur Noor",
  "block.minecraft.exposed_copper_golem_statue": "Seen Copurr Caty Scratchin Pozt",
  "block.minecraft.exposed_copper_grate": "Seen Copur Holz",
  "block.minecraft.exposed_copper_lantern": "Seen Copurr Lanturn",
  "block.minecraft.exposed_copper_trapdoor": "Seen Copur Trepnoor",
  "block.minecraft.exposed_cut_copper": "Seen sliced coppur",
  "block.minecraft.exposed_cut_copper_slab": "Seen Sliced Copurr Half Block",
  "block.minecraft.exposed_cut_copper_stairs": "Seen Sliced Copurr sters",
  "block.minecraft.exposed_lightning_rod": "Seen Liting Rot",
  "block.minecraft.farmland": "fudholz",
  "block.minecraft.fern": "furn",
  "block.minecraft.fire": "fireh",
  "block.minecraft.fire_coral": "HOT koral",
  "block.minecraft.fire_coral_block": "HOT coral cube",
  "block.minecraft.fire_coral_fan": "HOT koral fen",
  "block.minecraft.fire_coral_wall_fan": "Hot koral wull fan",
  "block.minecraft.firefly_bush": "U would not bliev ur eyes bush",
  "block.minecraft.fletching_table": "Fleching Tabel",
  "block.minecraft.flower_pot": "container for all the pretty plantz",
  "block.minecraft.flowering_azalea": "Tertl-shel-laik tree but in FLOWARZZ",
  "block.minecraft.flowering_azalea_leaves": "Flowerin azalee leevez",
  "block.minecraft.frogspawn": "toad ec",
  "block.minecraft.frosted_ice": "Thatz kowld!",
  "block.minecraft.furnace": "warm box",
  "block.minecraft.gilded_blackstone": "Some goldid bleckston",
  "block.minecraft.glass": "Glazz",
  "block.minecraft.glass_pane": "Glazz Payn",
  "block.minecraft.glow_lichen": "shiny moss",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Shiny blok",
  "block.minecraft.gold_ore": "Rockz wif Guld",
  "block.minecraft.golden_dandelion": "GULDEN FLOWAH",
  "block.minecraft.granite": "Red Rock",
  "block.minecraft.granite_slab": "Red Rock Sleb",
  "block.minecraft.granite_stairs": "Red Rock Stairz",
  "block.minecraft.granite_wall": "Red Rock Wal",
  "block.minecraft.grass": "Grazz",
  "block.minecraft.grass_block": "Gras blak",
  "block.minecraft.gravel": "fishy roks",
  "block.minecraft.gray_banner": "grai bahnor",
  "block.minecraft.gray_bed": "Greyh Bed",
  "block.minecraft.gray_candle": "Gra hot stik",
  "block.minecraft.gray_candle_cake": "Caek wif Gra Land pikl",
  "block.minecraft.gray_carpet": "Gray Cat Rug",
  "block.minecraft.gray_concrete": "Grey tough bluk",
  "block.minecraft.gray_concrete_powder": "Grey tough bluk powdr",
  "block.minecraft.gray_glazed_terracotta": "Grey mosaic",
  "block.minecraft.gray_shulker_box": "Grayish Shulker Bux",
  "block.minecraft.gray_stained_glass": "Grayly Stainedly Glazz",
  "block.minecraft.gray_stained_glass_pane": "Gray Staned Glas Pan",
  "block.minecraft.gray_terracotta": "Greyh Teracottah",
  "block.minecraft.gray_wool": "Gray Fur Bluk",
  "block.minecraft.green_banner": "grene bahnor",
  "block.minecraft.green_bed": "Gren Bed",
  "block.minecraft.green_candle": "Gren hot stik",
  "block.minecraft.green_candle_cake": "Caek wif Grin Candl",
  "block.minecraft.green_carpet": "Greenish Cat Rug",
  "block.minecraft.green_concrete": "Gren tough bluk",
  "block.minecraft.green_concrete_powder": "Gren tough bluk powdr",
  "block.minecraft.green_glazed_terracotta": "Gren mosaic",
  "block.minecraft.green_shulker_box": "Greenish Shulker Bux",
  "block.minecraft.green_stained_glass": "Grean Stainedly Glazz",
  "block.minecraft.green_stained_glass_pane": "Green Staned Glas Pan",
  "block.minecraft.green_terracotta": "Gren Teracottah",
  "block.minecraft.green_wool": "Greenish Fur Bluk",
  "block.minecraft.grindstone": "Removezstone",
  "block.minecraft.hanging_roots": "hangin stickz",
  "block.minecraft.hay_block": "Stwaw bael",
  "block.minecraft.heavy_core": "Heaviuss Coriuss",
  "block.minecraft.heavy_weighted_pressure_plate": "hvy weited presplat plet",
  "block.minecraft.honey_block": "Huny Bloc",
  "block.minecraft.honeycomb_block": "B thing bloc",
  "block.minecraft.hopper": "Huperr",
  "block.minecraft.horn_coral": "Jorn koral",
  "block.minecraft.horn_coral_block": "Jorn koral cube",
  "block.minecraft.horn_coral_fan": "Jorn koral fen",
  "block.minecraft.horn_coral_wall_fan": "Hurn koral wull fan",
  "block.minecraft.ice": "Frozen water",
  "block.minecraft.infested_chiseled_stone_bricks": "Kewl Rockz Wit Monsters",
  "block.minecraft.infested_cobblestone": "Invezzted Cooblestoon",
  "block.minecraft.infested_cracked_stone_bricks": "Brokin Rockz Wit Monsters",
  "block.minecraft.infested_deepslate": "dark ston wit weird thing inside idk",
  "block.minecraft.infested_mossy_stone_bricks": "Rockz Wit Mozs And Monsters",
  "block.minecraft.infested_stone": "Invezzted Stoon ",
  "block.minecraft.infested_stone_bricks": "Rockz Wit Patternz And Monsters",
  "block.minecraft.iron_bars": "Jeil Bahz",
  "block.minecraft.iron_block": "Blok of Irony",
  "block.minecraft.iron_chain": "Irun Shain",
  "block.minecraft.iron_door": "Iron Dor",
  "block.minecraft.iron_ore": "Rockz wuth Irun",
  "block.minecraft.iron_trapdoor": "Trappy Irun Kitty Dore",
  "block.minecraft.jack_o_lantern": "Big glowy squash",
  "block.minecraft.jigsaw": "Jig saw Blok",
  "block.minecraft.jukebox": "DJukbox",
  "block.minecraft.jungle_button": "Jongle Button",
  "block.minecraft.jungle_door": "Jungo Dor",
  "block.minecraft.jungle_fence": "Janggal Fence",
  "block.minecraft.jungle_fence_gate": "Janggal Fence Gate",
  "block.minecraft.jungle_hanging_sign": "Junglz Danglin' Sign",
  "block.minecraft.jungle_leaves": "jungel salad",
  "block.minecraft.jungle_log": "Junglz wodden lawg",
  "block.minecraft.jungle_planks": "Junglz wodden bloc",
  "block.minecraft.jungle_pressure_plate": "Jongle Prseure Pleitz",
  "block.minecraft.jungle_sapling": "baby jungel",
  "block.minecraft.jungle_shelf": "Jungo Shelv",
  "block.minecraft.jungle_sign": "Junglz Sign",
  "block.minecraft.jungle_slab": "Jungo Sleb",
  "block.minecraft.jungle_stairs": "Junggel Stairz",
  "block.minecraft.jungle_trapdoor": "Jongle Trap",
  "block.minecraft.jungle_wall_hanging_sign": "Junglz Danglin' Sign On Da Wall",
  "block.minecraft.jungle_wall_sign": "Junglz Sign on ur wall",
  "block.minecraft.jungle_wood": "Jungl Wuud",
  "block.minecraft.kelp": "Yucky lettuce",
  "block.minecraft.kelp_plant": "Yucky lettuce plant",
  "block.minecraft.ladder": "Ladr",
  "block.minecraft.lantern": "Lanturn",
  "block.minecraft.lapis_block": "Glosy Blu Bluk",
  "block.minecraft.lapis_ore": "Pritee Blu Oer",
  "block.minecraft.large_amethyst_bud": "Big purpur shinee",
  "block.minecraft.large_fern": "Larg furn",
  "block.minecraft.lava": "hot sauce",
  "block.minecraft.lava_cauldron": "big bukkit wif hot sauec",
  "block.minecraft.leaf_litter": "Cookd Leefz",
  "block.minecraft.lectern": "Book readin ting",
  "block.minecraft.lever": "Flipurr",
  "block.minecraft.light": "Shin'",
  "block.minecraft.light_blue_banner": "ligt bloo bahnor",
  "block.minecraft.light_blue_bed": "Lite Blu Bed",
  "block.minecraft.light_blue_candle": "Lite blu land pikl",
  "block.minecraft.light_blue_candle_cake": "Caek wif Lite blu Land pikl",
  "block.minecraft.light_blue_carpet": "Lite Blu Cat Rug",
  "block.minecraft.light_blue_concrete": "Layte Bluu tough bluk",
  "block.minecraft.light_blue_concrete_powder": "Layte Bluu tough bluk powdr",
  "block.minecraft.light_blue_glazed_terracotta": "Layte Bluu mosaic",
  "block.minecraft.light_blue_shulker_box": "Lite Blue Shulker Bux",
  "block.minecraft.light_blue_stained_glass": "Lit Bloo Staned Glas",
  "block.minecraft.light_blue_stained_glass_pane": "Lit Bloo Staned Glas Pan",
  "block.minecraft.light_blue_terracotta": "Lite Blu Teracottah",
  "block.minecraft.light_blue_wool": "Lite Bloo Fur Bluk",
  "block.minecraft.light_gray_banner": "ligt grai bahnor",
  "block.minecraft.light_gray_bed": "Lite Grehy Bed",
  "block.minecraft.light_gray_candle": "Lite gra hot stik",
  "block.minecraft.light_gray_candle_cake": "Caek wif Lite Grai Candl",
  "block.minecraft.light_gray_carpet": "Lite Gray Cat Rug",
  "block.minecraft.light_gray_concrete": "Layte Grey tough bluk",
  "block.minecraft.light_gray_concrete_powder": "Layte grey tough bluk powdr",
  "block.minecraft.light_gray_glazed_terracotta": "Layte Grey mosaic",
  "block.minecraft.light_gray_shulker_box": "Lite Gray Shulker Bux",
  "block.minecraft.light_gray_stained_glass": "Lightly Grayen Stainedly Grazz",
  "block.minecraft.light_gray_stained_glass_pane": "Lit Gray Staned Glas Pan",
  "block.minecraft.light_gray_terracotta": "Lite Greyh Teracottah",
  "block.minecraft.light_gray_wool": "Lite Gray Fur Bluk",
  "block.minecraft.light_weighted_pressure_plate": "liht weightefd prueusure platt",
  "block.minecraft.lightning_rod": "Litnin rot",
  "block.minecraft.lilac": "tall purpl flowr",
  "block.minecraft.lily_of_the_valley": "Lily of da Vallyz",
  "block.minecraft.lily_pad": "big watr leef",
  "block.minecraft.lime_banner": "liem bahnor",
  "block.minecraft.lime_bed": "Limeh Bed",
  "block.minecraft.lime_candle": "Liem hot stik",
  "block.minecraft.lime_candle_cake": "Caek wif Liem Land pickl",
  "block.minecraft.lime_carpet": "Limed Cat Rug",
  "block.minecraft.lime_concrete": "Layme tough bluk",
  "block.minecraft.lime_concrete_powder": "Layme tough bluk powdr",
  "block.minecraft.lime_glazed_terracotta": "Layme mosaic",
  "block.minecraft.lime_shulker_box": "Limd Shulker Bux",
  "block.minecraft.lime_stained_glass": "Lim Staned Glas",
  "block.minecraft.lime_stained_glass_pane": "Lim Staned Glas Pan",
  "block.minecraft.lime_terracotta": "Laym Teracottah",
  "block.minecraft.lime_wool": "Limd Fur Bluk",
  "block.minecraft.lodestone": "Loserstone",
  "block.minecraft.loom": "Lööm",
  "block.minecraft.magenta_banner": "megentre bahnor",
  "block.minecraft.magenta_bed": "Majenta Bed",
  "block.minecraft.magenta_candle": "Majentra land pikl",
  "block.minecraft.magenta_candle_cake": "Caek wif Majentra Land pikl",
  "block.minecraft.magenta_carpet": "Majenta Cat Rug",
  "block.minecraft.magenta_concrete": "Majenta tough bluk",
  "block.minecraft.magenta_concrete_powder": "Majentah tough bluk powdr",
  "block.minecraft.magenta_glazed_terracotta": "Majentah mosaic",
  "block.minecraft.magenta_shulker_box": "Majenta Shulker Bux",
  "block.minecraft.magenta_stained_glass": "Magentar Stainedlyd Glazz",
  "block.minecraft.magenta_stained_glass_pane": "Majenta Staned Glas Pan",
  "block.minecraft.magenta_terracotta": "Majenta Teracottah",
  "block.minecraft.magenta_wool": "Majenta Fur Bluk",
  "block.minecraft.magma_block": "Hot Bluk",
  "block.minecraft.mangrove_button": "Mangroff Button",
  "block.minecraft.mangrove_door": "Mangroff door",
  "block.minecraft.mangrove_fence": "mengruv fens",
  "block.minecraft.mangrove_fence_gate": "mengruv fens dor",
  "block.minecraft.mangrove_hanging_sign": "Mengroff Danglin' Sign",
  "block.minecraft.mangrove_leaves": "Mengroff salud",
  "block.minecraft.mangrove_log": "Mangroff lawg",
  "block.minecraft.mangrove_planks": "Mangroff PlAnKz",
  "block.minecraft.mangrove_pressure_plate": "Mengruv pwesuwe pleite",
  "block.minecraft.mangrove_propagule": "baby mangroff",
  "block.minecraft.mangrove_roots": "Mangroff roots",
  "block.minecraft.mangrove_shelf": "Mengroff Shelv",
  "block.minecraft.mangrove_sign": "Mengroff sihg",
  "block.minecraft.mangrove_slab": "Mengroff Half Block",
  "block.minecraft.mangrove_stairs": "Mangroff steppie",
  "block.minecraft.mangrove_trapdoor": "Mangroff Trap",
  "block.minecraft.mangrove_wall_hanging_sign": "Mengroff Danglin' Sign On Da Wall",
  "block.minecraft.mangrove_wall_sign": "Mangrof wal sin",
  "block.minecraft.mangrove_wood": "Mangroff wood",
  "block.minecraft.medium_amethyst_bud": "Midl purpur shinee",
  "block.minecraft.melon": "mlon",
  "block.minecraft.melon_stem": "melon stik",
  "block.minecraft.moss_block": "squishy gras blok",
  "block.minecraft.moss_carpet": "squeeshd grazz",
  "block.minecraft.mossy_cobblestone": "DURTY COBULSTOWN",
  "block.minecraft.mossy_cobblestone_slab": "Mossy Cobulston Sleb",
  "block.minecraft.mossy_cobblestone_stairs": "Mossy Cobulston Stairz",
  "block.minecraft.mossy_cobblestone_wall": "DURTY COBULSTOWN WALL",
  "block.minecraft.mossy_stone_brick_slab": "Mossy Ston Brick Sleb",
  "block.minecraft.mossy_stone_brick_stairs": "Mossy Ston Brik Stairz",
  "block.minecraft.mossy_stone_brick_wall": "Mossy Ston Brik Wal",
  "block.minecraft.mossy_stone_bricks": "Stacked Greenish Rockz",
  "block.minecraft.moving_piston": "dis piston is movin",
  "block.minecraft.mud": "dirty water",
  "block.minecraft.mud_brick_slab": "dirty water brik sleb",
  "block.minecraft.mud_brick_stairs": "dirty water steppie",
  "block.minecraft.mud_brick_wall": "dirty water brik wal",
  "block.minecraft.mud_bricks": "dirty water briks",
  "block.minecraft.muddy_mangrove_roots": "Mengroff dirt roots",
  "block.minecraft.mushroom_stem": "Mushroom Stem",
  "block.minecraft.mycelium": "miceliwm",
  "block.minecraft.nether_brick_fence": "Nether brik fens",
  "block.minecraft.nether_brick_slab": "Nether brik sleb",
  "block.minecraft.nether_brick_stairs": "Nether Brik Sters",
  "block.minecraft.nether_brick_wall": "Nether brik Wal",
  "block.minecraft.nether_bricks": "Nether Brickz",
  "block.minecraft.nether_gold_ore": "Nether or wif Guld",
  "block.minecraft.nether_portal": "Nether purtal",
  "block.minecraft.nether_quartz_ore": "Nether Kworts Ore",
  "block.minecraft.nether_sprouts": "Nether Sprowts",
  "block.minecraft.nether_wart": "Icky Nether plant",
  "block.minecraft.nether_wart_block": "Nether warz bluk",
  "block.minecraft.netherite_block": "Bluk ov Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Beetbokz",
  "block.minecraft.oak_button": "Oak Button",
  "block.minecraft.oak_door": "Oak Dor",
  "block.minecraft.oak_fence": "oke fenz",
  "block.minecraft.oak_fence_gate": "Oke Wod fence Gate",
  "block.minecraft.oak_hanging_sign": "Ook Danglin' Sign",
  "block.minecraft.oak_leaves": "oak salad",
  "block.minecraft.oak_log": "Oak lawg",
  "block.minecraft.oak_planks": "oak bloc",
  "block.minecraft.oak_pressure_plate": "Oak Prseure Pleitz",
  "block.minecraft.oak_sapling": "baby oak",
  "block.minecraft.oak_shelf": "Oke Shelv",
  "block.minecraft.oak_sign": "Ook Sign",
  "block.minecraft.oak_slab": "Oak Sleb",
  "block.minecraft.oak_stairs": "WOAKOAK Stairz",
  "block.minecraft.oak_trapdoor": "Oak Trap",
  "block.minecraft.oak_wall_hanging_sign": "Ook Danglin' Sign On Da Wall",
  "block.minecraft.oak_wall_sign": "Ook Sign on ur wall",
  "block.minecraft.oak_wood": "Oak Wuud",
  "block.minecraft.observer": "CREEPY StaLKeR DuDE",
  "block.minecraft.obsidian": "HARDEST THING EVAR",
  "block.minecraft.ochre_froglight": "Yelo toedshin",
  "block.minecraft.ominous_banner": "skeri bahnor",
  "block.minecraft.open_eyeblossom": "Wakey eye flowah",
  "block.minecraft.orange_banner": "oreng bahnor",
  "block.minecraft.orange_bed": "Orang Bed",
  "block.minecraft.orange_candle": "Ornge land pikl",
  "block.minecraft.orange_candle_cake": "Caek wif Ornge Land pikl",
  "block.minecraft.orange_carpet": "Ornge Cat Rug",
  "block.minecraft.orange_concrete": "Orang tough bluk",
  "block.minecraft.orange_concrete_powder": "Orang tough bluk powdr",
  "block.minecraft.orange_glazed_terracotta": "Orang mosaic",
  "block.minecraft.orange_shulker_box": "Ornge Shulker Bux",
  "block.minecraft.orange_stained_glass": "Oranz Staned Glas",
  "block.minecraft.orange_stained_glass_pane": "Oranz Staned Glas Pan",
  "block.minecraft.orange_terracotta": "Orang Teracottah",
  "block.minecraft.orange_tulip": "Ornge tulehp",
  "block.minecraft.orange_wool": "Ornj Fur Bluk",
  "block.minecraft.oxeye_daisy": "big wite flowr",
  "block.minecraft.oxidized_chiseled_copper": "Very-old Pretteh Copurr",
  "block.minecraft.oxidized_copper": "Very-old copurr",
  "block.minecraft.oxidized_copper_bars": "Very-old Copurr Jeil Bahz",
  "block.minecraft.oxidized_copper_bulb": "Very-old Copurr Bob",
  "block.minecraft.oxidized_copper_chain": "Very-old Copurr Shain",
  "block.minecraft.oxidized_copper_chest": "Very-old Copurr Bokz",
  "block.minecraft.oxidized_copper_door": "Very-old Copurr Noor",
  "block.minecraft.oxidized_copper_golem_statue": "Very-old Copurr Caty Scratchin Pozt",
  "block.minecraft.oxidized_copper_grate": "Very-old Coper Holz",
  "block.minecraft.oxidized_copper_lantern": "Very-old Copurr Lanturn",
  "block.minecraft.oxidized_copper_trapdoor": "Very-old Copur Trepnoor",
  "block.minecraft.oxidized_cut_copper": "Very-old sliced copurr",
  "block.minecraft.oxidized_cut_copper_slab": "Very-old Copurr sleb",
  "block.minecraft.oxidized_cut_copper_stairs": "Very-old Copurr sters",
  "block.minecraft.oxidized_lightning_rod": "Very-old Liting Rot",
  "block.minecraft.packed_ice": "Pack'd Frozen Water",
  "block.minecraft.packed_mud": "dirty water compact",
  "block.minecraft.pale_hanging_moss": "Whity falling greeny",
  "block.minecraft.pale_moss_block": "Wite noodles in a box",
  "block.minecraft.pale_moss_carpet": "Wite noodles spilld on flor",
  "block.minecraft.pale_oak_button": "Wite Ok Button",
  "block.minecraft.pale_oak_door": "Wite Ok Dor",
  "block.minecraft.pale_oak_fence": "Wite Oak Fens",
  "block.minecraft.pale_oak_fence_gate": "Wite Ok Geit",
  "block.minecraft.pale_oak_hanging_sign": "Wite Ook Danglin' Sign",
  "block.minecraft.pale_oak_leaves": "Wite Ok salad",
  "block.minecraft.pale_oak_log": "Wite Ok Lawwg",
  "block.minecraft.pale_oak_planks": "Wite ook Planx",
  "block.minecraft.pale_oak_pressure_plate": "Wite Oke Prseure Pleitz",
  "block.minecraft.pale_oak_sapling": "Smol Wite Ook",
  "block.minecraft.pale_oak_shelf": "Wite Oke Shelv",
  "block.minecraft.pale_oak_sign": "Wite Ok Sign",
  "block.minecraft.pale_oak_slab": "Wite ook Sleb",
  "block.minecraft.pale_oak_stairs": "Wite Oke Steirz",
  "block.minecraft.pale_oak_trapdoor": "Wite Ok Trepdor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Wite Ook danglin' Sign On da Wal",
  "block.minecraft.pale_oak_wall_sign": "Wite Ok sign on ur wal",
  "block.minecraft.pale_oak_wood": "Wite ook Wud",
  "block.minecraft.pearlescent_froglight": "Perlecsetn toedshin",
  "block.minecraft.peony": "pony plant",
  "block.minecraft.petrified_oak_slab": "Petrifid Oak Sleb",
  "block.minecraft.piglin_head": "Piglin Hed",
  "block.minecraft.piglin_wall_head": "Piglin Wall Hed",
  "block.minecraft.pink_banner": "pinek bahnor",
  "block.minecraft.pink_bed": "Pinky Bed",
  "block.minecraft.pink_candle": "Pinc land pikl",
  "block.minecraft.pink_candle_cake": "Caek wif Pinc Land pikl",
  "block.minecraft.pink_carpet": "Pinky Cat Rug",
  "block.minecraft.pink_concrete": "Pinkyyy tough bluk",
  "block.minecraft.pink_concrete_powder": "Pinkyyy tough bluk powdr",
  "block.minecraft.pink_glazed_terracotta": "Pinkyyy mosaic",
  "block.minecraft.pink_petals": "Pinky Pretty Thingz",
  "block.minecraft.pink_shulker_box": "Pinky Shulker Bux",
  "block.minecraft.pink_stained_glass": "Pingk Staned Glas",
  "block.minecraft.pink_stained_glass_pane": "Pingk Staned Glas Pan",
  "block.minecraft.pink_terracotta": "Pinky Teracottah",
  "block.minecraft.pink_tulip": "Pink tulehp",
  "block.minecraft.pink_wool": "Pinky Fur Bluk",
  "block.minecraft.piston": "Pushur",
  "block.minecraft.piston_head": "pushy-uppy face",
  "block.minecraft.pitcher_crop": "Bottl Krop",
  "block.minecraft.pitcher_plant": "Bottl Plant",
  "block.minecraft.player_head": "Kat Hed",
  "block.minecraft.player_head.named": "%s's Hed",
  "block.minecraft.player_wall_head": "Cat Wall Hed",
  "block.minecraft.podzol": "Durtee durt",
  "block.minecraft.pointed_dripstone": "Sharp cave rok",
  "block.minecraft.polished_andesite": "pretteh grey rock",
  "block.minecraft.polished_andesite_slab": "Pretteh Grey Rock Sleb",
  "block.minecraft.polished_andesite_stairs": "Pretteh Grey Rock Stairz",
  "block.minecraft.polished_basalt": "cleened baisolt",
  "block.minecraft.polished_blackstone": "polised bleckston",
  "block.minecraft.polished_blackstone_brick_slab": "shiny blak rok brik slab",
  "block.minecraft.polished_blackstone_brick_stairs": "shiny blak rok brik sters",
  "block.minecraft.polished_blackstone_brick_wall": "polised bleck brik wal",
  "block.minecraft.polished_blackstone_bricks": "Preteh bleck rockz stackd",
  "block.minecraft.polished_blackstone_button": "shiny blak rok buton",
  "block.minecraft.polished_blackstone_pressure_plate": "shiny blak rok step button",
  "block.minecraft.polished_blackstone_slab": "shiny blak rok sleb",
  "block.minecraft.polished_blackstone_stairs": "shiny blak rok sters",
  "block.minecraft.polished_blackstone_wall": "shiny blak rok wal",
  "block.minecraft.polished_deepslate": "shiny dark ston",
  "block.minecraft.polished_deepslate_slab": "shiny dark ston sleb",
  "block.minecraft.polished_deepslate_stairs": "shiny dark ston stairz",
  "block.minecraft.polished_deepslate_wall": "shiny dark ston wal",
  "block.minecraft.polished_diorite": "pretteh kitteh litter rockz",
  "block.minecraft.polished_diorite_slab": "Pretteh Diorito Sleb",
  "block.minecraft.polished_diorite_stairs": "Pretteh Diorito Stairz",
  "block.minecraft.polished_granite": "pretteh red rock",
  "block.minecraft.polished_granite_slab": "Pretteh Red Rock Sleb",
  "block.minecraft.polished_granite_stairs": "Pretteh Red Rock Stairz",
  "block.minecraft.polished_tuff": "Shineh Tff",
  "block.minecraft.polished_tuff_slab": "Shineh Tff Swab",
  "block.minecraft.polished_tuff_stairs": "Shineh Tff Starz",
  "block.minecraft.polished_tuff_wall": "Shineh Tff Wal",
  "block.minecraft.poppy": "poopy",
  "block.minecraft.potatoes": "Taturs",
  "block.minecraft.potted_acacia_sapling": "Pottd acazia saplin",
  "block.minecraft.potted_allium": "Pottd alium",
  "block.minecraft.potted_azalea_bush": "Pottd Alakazam",
  "block.minecraft.potted_azure_bluet": "Pottd azur blut",
  "block.minecraft.potted_bamboo": "Pottd green stick",
  "block.minecraft.potted_birch_sapling": "Pottd birsh saplin",
  "block.minecraft.potted_blue_orchid": "Pottd bluu orkid",
  "block.minecraft.potted_brown_mushroom": "Pottd bron shroom",
  "block.minecraft.potted_cactus": "Pottd cacus",
  "block.minecraft.potted_cherry_sapling": "Pottd sakura saplin",
  "block.minecraft.potted_closed_eyeblossom": "Pottd sleepy eye flowah",
  "block.minecraft.potted_cornflower": "Pottd Cornflowerpower",
  "block.minecraft.potted_crimson_fungus": "Pottd Crimzin Foongiz",
  "block.minecraft.potted_crimson_roots": "Pottd Crimzn Rutez",
  "block.minecraft.potted_dandelion": "Pottd danksdelion",
  "block.minecraft.potted_dark_oak_sapling": "Pottd darkok saplin",
  "block.minecraft.potted_dead_bush": "Pottd ded bujsh",
  "block.minecraft.potted_fern": "Pottd ferrn",
  "block.minecraft.potted_flowering_azalea_bush": "Pottd Flowerig Alakazam",
  "block.minecraft.potted_golden_dandelion": "Pottd goldan danksdelion",
  "block.minecraft.potted_jungle_sapling": "Pottd junle saplin",
  "block.minecraft.potted_lily_of_the_valley": "Pottd Lily of za Valley",
  "block.minecraft.potted_mangrove_propagule": "Mangroff baby inpot",
  "block.minecraft.potted_oak_sapling": "Pottd ok saplin",
  "block.minecraft.potted_open_eyeblossom": "Pottd wakey eye flowah",
  "block.minecraft.potted_orange_tulip": "Pottd orang tlip",
  "block.minecraft.potted_oxeye_daisy": "Pottd oxyey daisye",
  "block.minecraft.potted_pale_oak_sapling": "Pottd smol wite ook",
  "block.minecraft.potted_pink_tulip": "Pottd pikk tlip",
  "block.minecraft.potted_poppy": "Pottd popi",
  "block.minecraft.potted_red_mushroom": "Pottd red shroom",
  "block.minecraft.potted_red_tulip": "Pottd red tlip",
  "block.minecraft.potted_spruce_sapling": "Pottd sprus saplin",
  "block.minecraft.potted_torchflower": "Pottd burny flowr",
  "block.minecraft.potted_warped_fungus": "Pottd Warpt Foongis",
  "block.minecraft.potted_warped_roots": "Pottd Warpd Rootz",
  "block.minecraft.potted_white_tulip": "Pottd wit tlip",
  "block.minecraft.potted_wither_rose": "Pottd Wither Roos",
  "block.minecraft.powder_snow": "Powdr Sno",
  "block.minecraft.powder_snow_cauldron": "Big bukkit wit Powdr Sno",
  "block.minecraft.powered_rail": "PUWERD RAIL",
  "block.minecraft.prismarine": "Prizmarine",
  "block.minecraft.prismarine_brick_slab": "Prizmarine Bric slap",
  "block.minecraft.prismarine_brick_stairs": "Prizmarine bric strs",
  "block.minecraft.prismarine_bricks": "Prizmarine Briks",
  "block.minecraft.prismarine_slab": "Prizmarine Sleb",
  "block.minecraft.prismarine_stairs": "Prizmarine stepz",
  "block.minecraft.prismarine_wall": "Prizmarine Wal",
  "block.minecraft.pumpkin": "Pangkan",
  "block.minecraft.pumpkin_stem": "Dat thing teh orange scary thing grows on",
  "block.minecraft.purple_banner": "purrrpel bahnor",
  "block.minecraft.purple_bed": "Parpal Bed",
  "block.minecraft.purple_candle": "Parpal hot stik",
  "block.minecraft.purple_candle_cake": "Caek wif Purpl Candl",
  "block.minecraft.purple_carpet": "Prple Cat Rug",
  "block.minecraft.purple_concrete": "Perpl tough bluk",
  "block.minecraft.purple_concrete_powder": "Perpl tough bluk powdr",
  "block.minecraft.purple_glazed_terracotta": "Perpl mosaic",
  "block.minecraft.purple_shulker_box": "Parpal Shulker Bux",
  "block.minecraft.purple_stained_glass": "Purply Stainedly Glazz",
  "block.minecraft.purple_stained_glass_pane": "Parpal Staned Glas Pan",
  "block.minecraft.purple_terracotta": "Parpal Teracottah",
  "block.minecraft.purple_wool": "Parpal Fur Bluk",
  "block.minecraft.purpur_block": "OOO PURPUR Bluk",
  "block.minecraft.purpur_pillar": "OOO PURPUR Bluk w/ Stripez",
  "block.minecraft.purpur_slab": "OOO PURPUR Bluk Cut In Half",
  "block.minecraft.purpur_stairs": "OOO PURPUR Bluk U Can Climb",
  "block.minecraft.quartz_block": "Blak Av Kworts",
  "block.minecraft.quartz_bricks": "Kwartz brickz",
  "block.minecraft.quartz_pillar": "Kwartz piler",
  "block.minecraft.quartz_slab": "White half blok",
  "block.minecraft.quartz_stairs": "Kworts Sters",
  "block.minecraft.rail": "Trakz",
  "block.minecraft.raw_copper_block": "Bluk ov moldy wurst",
  "block.minecraft.raw_gold_block": "Bluk ov shiny coal",
  "block.minecraft.raw_iron_block": "Bluk ov RAWWWW irun",
  "block.minecraft.red_banner": "Red bahnor",
  "block.minecraft.red_bed": "Reddish Bed",
  "block.minecraft.red_candle": "Red land pikl",
  "block.minecraft.red_candle_cake": "Caek wif Rd Candl",
  "block.minecraft.red_carpet": "Redish Cat Rug",
  "block.minecraft.red_concrete": "Redish tough bluk",
  "block.minecraft.red_concrete_powder": "Redish tough bluk powdr",
  "block.minecraft.red_glazed_terracotta": "Redish mosaic",
  "block.minecraft.red_mushroom": "blood Mooshroom",
  "block.minecraft.red_mushroom_block": "blood Mushroom blok",
  "block.minecraft.red_nether_brick_slab": "Red Sleb that Nether bricks",
  "block.minecraft.red_nether_brick_stairs": "Red Nether Brik Sters",
  "block.minecraft.red_nether_brick_wall": "Red Nether brik Wal",
  "block.minecraft.red_nether_bricks": "Red Nether brik",
  "block.minecraft.red_sand": "Red sand",
  "block.minecraft.red_sandstone": "Warmy sanstown",
  "block.minecraft.red_sandstone_slab": "Rds litterbox slab",
  "block.minecraft.red_sandstone_stairs": "Rds litterbox sters",
  "block.minecraft.red_sandstone_wall": "Redy Sandston Wal",
  "block.minecraft.red_shulker_box": "Redish Shulker Bux",
  "block.minecraft.red_stained_glass": "Read Stainedly Glazz",
  "block.minecraft.red_stained_glass_pane": "rud thin culurd thingy",
  "block.minecraft.red_terracotta": "Reddish Teracottah",
  "block.minecraft.red_tulip": "Red tulehp",
  "block.minecraft.red_wool": "WLR3D Fur Bluk",
  "block.minecraft.redstone_block": "Redstone Bluk",
  "block.minecraft.redstone_lamp": "Redstone lapm",
  "block.minecraft.redstone_ore": "Rockz wif Redstone",
  "block.minecraft.redstone_torch": "Glowy Redstone Stik",
  "block.minecraft.redstone_wall_torch": "Glowy Redstone Wall Stik",
  "block.minecraft.redstone_wire": "Redstone Whyr",
  "block.minecraft.reinforced_deepslate": "dark ston wit weird thing outside idk",
  "block.minecraft.repeater": "Redstone Repeetah",
  "block.minecraft.repeating_command_block": "Again Doing Block",
  "block.minecraft.resin_block": "Yello stiky blok",
  "block.minecraft.resin_brick_slab": "Yelo stiky brik slab",
  "block.minecraft.resin_brick_stairs": "Yelo stiky stairz",
  "block.minecraft.resin_brick_wall": "Yelo stiky brik wal",
  "block.minecraft.resin_bricks": "Yelo stiky brix",
  "block.minecraft.resin_clump": "Yelo poop",
  "block.minecraft.respawn_anchor": "Reezpon mawgic blok",
  "block.minecraft.rooted_dirt": "durt wit stickz",
  "block.minecraft.rose_bush": "Rose brah",
  "block.minecraft.sand": "litter box stuffs",
  "block.minecraft.sandstone": "litter box rockz",
  "block.minecraft.sandstone_slab": "sansdstoen sleb",
  "block.minecraft.sandstone_stairs": "Sanston Sters",
  "block.minecraft.sandstone_wall": "Sandston Wal",
  "block.minecraft.scaffolding": "Sceffolding",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk Cat-alist",
  "block.minecraft.sculk_sensor": "Sculk detektor",
  "block.minecraft.sculk_shrieker": "Sculk yeller",
  "block.minecraft.sculk_vein": "Smol Sculk",
  "block.minecraft.sea_lantern": "See lanturn",
  "block.minecraft.sea_pickle": "See pikol",
  "block.minecraft.seagrass": "MARIN GRAZZ",
  "block.minecraft.set_spawn": "hear is new kat home!!",
  "block.minecraft.short_dry_grass": "Shurt Dry Graz",
  "block.minecraft.short_grass": "Smol Grazz",
  "block.minecraft.shroomlight": "Shroomy Lite",
  "block.minecraft.shulker_box": "Shulker Bux",
  "block.minecraft.skeleton_skull": "Skellyton hed",
  "block.minecraft.skeleton_wall_skull": "Spooke Scury Skeletun Wall Hed",
  "block.minecraft.slime_block": "bouncy green stuff",
  "block.minecraft.small_amethyst_bud": "Smol purpur shinee",
  "block.minecraft.small_dripleaf": "Smol fall thru plantt",
  "block.minecraft.smithing_table": "Smissing Table",
  "block.minecraft.smoker": "Za Smoker",
  "block.minecraft.smooth_basalt": "smoos bazalt",
  "block.minecraft.smooth_quartz": "Smooth Wite Kat Blawk",
  "block.minecraft.smooth_quartz_slab": "Smooth Qwartz Sleb",
  "block.minecraft.smooth_quartz_stairs": "Smooth Qwartz Stairz",
  "block.minecraft.smooth_red_sandstone": "Smud warmy sanstown",
  "block.minecraft.smooth_red_sandstone_slab": "Smooth Redy Sandston Sleb",
  "block.minecraft.smooth_red_sandstone_stairs": "Smooth Redy Sandston Stairz",
  "block.minecraft.smooth_sandstone": "smooth litter box rockz",
  "block.minecraft.smooth_sandstone_slab": "Smooth Sandston Sleb",
  "block.minecraft.smooth_sandstone_stairs": "Smooth Sandston Stairz",
  "block.minecraft.smooth_stone": "Smooth Rockz",
  "block.minecraft.smooth_stone_slab": "Smooth Ston Sleb",
  "block.minecraft.sniffer_egg": "Sniffr ec",
  "block.minecraft.snow": "Cold white stuff",
  "block.minecraft.snow_block": "Snowi bloc",
  "block.minecraft.soul_campfire": "sul camfiri",
  "block.minecraft.soul_fire": "bloo hot stuff",
  "block.minecraft.soul_lantern": "Sol Lanturn",
  "block.minecraft.soul_sand": "sole snd",
  "block.minecraft.soul_soil": "ded peeple dirt",
  "block.minecraft.soul_torch": "Creepy torch thingy",
  "block.minecraft.soul_wall_torch": "Creepy torch thingy on de wal",
  "block.minecraft.spawn.not_valid": "U iz homelezz nao cuz ur hoem bed or charjd respwn anchr, or wuz obstructd",
  "block.minecraft.spawner": "bad kitteh maekr",
  "block.minecraft.spawner.desc1": "Pulay wiv spon ec:",
  "block.minecraft.spawner.desc2": "setz mahbstrr tyep",
  "block.minecraft.sponge": "Spangblob",
  "block.minecraft.spore_blossom": "snees flowar",
  "block.minecraft.spruce_button": "Sproos Button",
  "block.minecraft.spruce_door": "Spruz Dor",
  "block.minecraft.spruce_fence": "Sprce Fenc",
  "block.minecraft.spruce_fence_gate": "Sprce Fenc Gaet",
  "block.minecraft.spruce_hanging_sign": "Sproos Danglin' Sign",
  "block.minecraft.spruce_leaves": "spruce salad",
  "block.minecraft.spruce_log": "Spruce lawg",
  "block.minecraft.spruce_planks": "dark wooden bloc",
  "block.minecraft.spruce_pressure_plate": "Sproos Prseure Pleitz",
  "block.minecraft.spruce_sapling": "baby spurce",
  "block.minecraft.spruce_shelf": "Sproos Shelv",
  "block.minecraft.spruce_sign": "Sproos Sign",
  "block.minecraft.spruce_slab": "Sproos Sleb",
  "block.minecraft.spruce_stairs": "Sproos Stairz",
  "block.minecraft.spruce_trapdoor": "Sproos Trap",
  "block.minecraft.spruce_wall_hanging_sign": "Sproos Danglin' Sign On Da Wall",
  "block.minecraft.spruce_wall_sign": "Sproos Sign on ur wall",
  "block.minecraft.spruce_wood": "Spruz Wuud",
  "block.minecraft.sticky_piston": "Stickeh Pushurr",
  "block.minecraft.stone": "Rock",
  "block.minecraft.stone_brick_slab": "Ston Brick Sleb",
  "block.minecraft.stone_brick_stairs": "Stone Brik Sters",
  "block.minecraft.stone_brick_wall": "Ston Brik Wal",
  "block.minecraft.stone_bricks": "Stackd Rockz",
  "block.minecraft.stone_button": "Stoon Button",
  "block.minecraft.stone_pressure_plate": "Stone Presar Plat",
  "block.minecraft.stone_slab": "stne slab",
  "block.minecraft.stone_stairs": "Ston Stairz",
  "block.minecraft.stonecutter": "Shrpy movin thingy",
  "block.minecraft.stripped_acacia_log": "Naked Acashuh lawg",
  "block.minecraft.stripped_acacia_wood": "Naked Acashuh Bawk",
  "block.minecraft.stripped_bamboo_block": "bluk ov naked bamboo",
  "block.minecraft.stripped_birch_log": "Naked berch lawg",
  "block.minecraft.stripped_birch_wood": "Naked Berch Bawk",
  "block.minecraft.stripped_cherry_log": "Naked Sakura lawg",
  "block.minecraft.stripped_cherry_wood": "Naked Sakura Bawk",
  "block.minecraft.stripped_crimson_hyphae": "Da werd red nehtr plnta but neked",
  "block.minecraft.stripped_crimson_stem": "Nakd crimzon stem",
  "block.minecraft.stripped_dark_oak_log": "Naked shaded-O lawg",
  "block.minecraft.stripped_dark_oak_wood": "Naked Blak Oac Bawk",
  "block.minecraft.stripped_jungle_log": "Naked juncle lawg",
  "block.minecraft.stripped_jungle_wood": "Naked Juggle Bawk",
  "block.minecraft.stripped_mangrove_log": "naked mangroff lawg",
  "block.minecraft.stripped_mangrove_wood": "naked mangroff wuud",
  "block.minecraft.stripped_oak_log": "Naked Oac lawg",
  "block.minecraft.stripped_oak_wood": "Naked Oac Bawk",
  "block.minecraft.stripped_pale_oak_log": "Naked Wite Ook Lawg",
  "block.minecraft.stripped_pale_oak_wood": "Naked Wite Oke Wud",
  "block.minecraft.stripped_spruce_log": "Naked spruice lawg",
  "block.minecraft.stripped_spruce_wood": "Naked Sproos Bawk",
  "block.minecraft.stripped_warped_hyphae": "Da werd nethr plnt butt nakie",
  "block.minecraft.stripped_warped_stem": "Naekt Warpt Stem",
  "block.minecraft.structure_block": "Strcter blek",
  "block.minecraft.structure_void": "Blank space",
  "block.minecraft.sugar_cane": "BAMBOOO",
  "block.minecraft.sunflower": "Rly tall flowr",
  "block.minecraft.suspicious_gravel": "Sussy grey thing",
  "block.minecraft.suspicious_sand": "Sussy litter box",
  "block.minecraft.sweet_berry_bush": "Sweet Bery Bush",
  "block.minecraft.tall_dry_grass": "Tawl Dry Graz",
  "block.minecraft.tall_grass": "Tall Gras",
  "block.minecraft.tall_seagrass": "TOLL MARIN GRAZZ",
  "block.minecraft.target": "Tawget",
  "block.minecraft.terracotta": "Terrakattah",
  "block.minecraft.test_block": "Tes blok",
  "block.minecraft.test_instance_block": "Tez instenz bluk",
  "block.minecraft.tinted_glass": "Skary glazz",
  "block.minecraft.tnt": "BOOM",
  "block.minecraft.tnt.disabled": "No boom 4 u :(",
  "block.minecraft.torch": "burny stick",
  "block.minecraft.torchflower": "burny flowr",
  "block.minecraft.torchflower_crop": "burny flowr crop",
  "block.minecraft.trapped_chest": "Rigged Cat Box",
  "block.minecraft.trial_spawner": "Dungenz Kitteh Maekr",
  "block.minecraft.tripwire": "String",
  "block.minecraft.tripwire_hook": "String huk",
  "block.minecraft.tube_coral": "Tuf koral",
  "block.minecraft.tube_coral_block": "Tuf koral cube",
  "block.minecraft.tube_coral_fan": "Tuf koral fen",
  "block.minecraft.tube_coral_wall_fan": "Tueb Corahl Wahll Fahn",
  "block.minecraft.tuff": "Tfff",
  "block.minecraft.tuff_brick_slab": "Tff Brik Sleb",
  "block.minecraft.tuff_brick_stairs": "Tff Brik Stepz",
  "block.minecraft.tuff_brick_wall": "Tff Brik Wal",
  "block.minecraft.tuff_bricks": "Tff Briks",
  "block.minecraft.tuff_slab": "Tff Sleb",
  "block.minecraft.tuff_stairs": "Tff Stepz",
  "block.minecraft.tuff_wall": "Tff Wal",
  "block.minecraft.turtle_egg": "Tertl ball",
  "block.minecraft.twisting_vines": "Spyrale noodel",
  "block.minecraft.twisting_vines_plant": "Spyrale noodel plont",
  "block.minecraft.vault": "Moneh box",
  "block.minecraft.verdant_froglight": "Grin toedshin",
  "block.minecraft.vine": "Climbin plantz",
  "block.minecraft.void_air": "vOoId",
  "block.minecraft.wall_torch": "burny stick on de wall",
  "block.minecraft.warped_button": "Warpt Thingy",
  "block.minecraft.warped_door": "Warpt Big Kat Door",
  "block.minecraft.warped_fence": "Warpt Fenc",
  "block.minecraft.warped_fence_gate": "Warpt Fenc Gaet",
  "block.minecraft.warped_fungus": "Warpt Foongis",
  "block.minecraft.warped_hanging_sign": "Warpt Danglin' Sign",
  "block.minecraft.warped_hyphae": "Wierd nethr plant",
  "block.minecraft.warped_nylium": "wrped nyanium",
  "block.minecraft.warped_planks": "Warpt Plaenkz",
  "block.minecraft.warped_pressure_plate": "Wapt Weight Plaet",
  "block.minecraft.warped_roots": "Warpt Roods",
  "block.minecraft.warped_shelf": "Warpt Shelv",
  "block.minecraft.warped_sign": "Warpt Texxt Bawrd",
  "block.minecraft.warped_slab": "Warpt Slaep",
  "block.minecraft.warped_stairs": "Worp Katstairs",
  "block.minecraft.warped_stem": "Warpt trunkk",
  "block.minecraft.warped_trapdoor": "Warpt Kat Door",
  "block.minecraft.warped_wall_hanging_sign": "Warpt Danglin' Sign On Da Wall",
  "block.minecraft.warped_wall_sign": "Warpt wol book",
  "block.minecraft.warped_wart_block": "Warpt Pimpl Blawk",
  "block.minecraft.water": "Watr",
  "block.minecraft.water_cauldron": "big bukkit wit watr",
  "block.minecraft.waxed_chiseled_copper": "Shiny Preteh Copur",
  "block.minecraft.waxed_copper_bars": "Shiny Copurr Jeil Bahz",
  "block.minecraft.waxed_copper_block": "Shiny Blok of copurr",
  "block.minecraft.waxed_copper_bulb": "Shineh Coper Bob",
  "block.minecraft.waxed_copper_chain": "Shiny Copurr Shain",
  "block.minecraft.waxed_copper_chest": "Shineh Copurr Bokz",
  "block.minecraft.waxed_copper_door": "Shineh Copurr Noor",
  "block.minecraft.waxed_copper_golem_statue": "Shineh Copurr Caty Scratchin Pozt",
  "block.minecraft.waxed_copper_grate": "Shineh Copur Holz",
  "block.minecraft.waxed_copper_lantern": "Shiny Copurr Lanturn",
  "block.minecraft.waxed_copper_trapdoor": "Shiny Coper Trapnoor",
  "block.minecraft.waxed_cut_copper": "Waxd an sliecd copurr",
  "block.minecraft.waxed_cut_copper_slab": "Shiny slised copurr sleb",
  "block.minecraft.waxed_cut_copper_stairs": "Shineh slised copurr sters",
  "block.minecraft.waxed_exposed_chiseled_copper": "Shiny Seen Pretteh Copur",
  "block.minecraft.waxed_exposed_copper": "Shiny Seen Copurr",
  "block.minecraft.waxed_exposed_copper_bars": "Shiny Seen Copurr Jeil Bahz",
  "block.minecraft.waxed_exposed_copper_bulb": "Shiny Seen Copurr Bob",
  "block.minecraft.waxed_exposed_copper_chain": "Shiny Seen Copurr Shain",
  "block.minecraft.waxed_exposed_copper_chest": "Shiny Seen Copurr Bokz",
  "block.minecraft.waxed_exposed_copper_door": "Shiny Seen Copurr Noor",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Shineh Seen Copurr Caty Scratchin Pozt",
  "block.minecraft.waxed_exposed_copper_grate": "Shiny Seen Copur Holz",
  "block.minecraft.waxed_exposed_copper_lantern": "Shiny Seen Copurr Lanturn",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Shiny Seen Copurr Trepnoor",
  "block.minecraft.waxed_exposed_cut_copper": "Shiny Seen Sliced Copurr",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Shineh Seen Sliced Steal Half Block",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Shiny Seen Sliced Steal sters",
  "block.minecraft.waxed_exposed_lightning_rod": "Shineh Seen Liting Rot",
  "block.minecraft.waxed_lightning_rod": "Shineh Liting Rot",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Shiny Old Pretteh Copur",
  "block.minecraft.waxed_oxidized_copper": "Shiny very-old copurr",
  "block.minecraft.waxed_oxidized_copper_bars": "Shiny Very-old Copurr Jeil Bahz",
  "block.minecraft.waxed_oxidized_copper_bulb": "Shiny Old Copurr-bob",
  "block.minecraft.waxed_oxidized_copper_chain": "Shineh Very-old Copurr Shain",
  "block.minecraft.waxed_oxidized_copper_chest": "Shiny Very-old Copurr Bokz",
  "block.minecraft.waxed_oxidized_copper_door": "Shiny Old Copurr Noor",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Shineh Very-old Copurr Caty Scratchin Pozt",
  "block.minecraft.waxed_oxidized_copper_grate": "Shiny Old Copur holz",
  "block.minecraft.waxed_oxidized_copper_lantern": "Shineh Very-old Copurr Lanturn",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Shiny Old Copurr Trepnoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Shiny very-old sliced copurr",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Shiny very-old copurr sleb",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Shiny cery-old copurr sters",
  "block.minecraft.waxed_oxidized_lightning_rod": "Shineh Very-old Liting Rot",
  "block.minecraft.waxed_weathered_chiseled_copper": "Shineh Yucky Preteh Copur",
  "block.minecraft.waxed_weathered_copper": "Yucky old copurr",
  "block.minecraft.waxed_weathered_copper_bars": "Shiny Yucky Copurr Jeil Bahz",
  "block.minecraft.waxed_weathered_copper_bulb": "Shiny Yucky Copurr Bob",
  "block.minecraft.waxed_weathered_copper_chain": "Shiny Yuckeh Copurr Shain",
  "block.minecraft.waxed_weathered_copper_chest": "Shiny Yucky Copurr Bokz",
  "block.minecraft.waxed_weathered_copper_door": "Shiny Yucky Copur Noor",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Shineh Yucky Copurr Caty Scratchin Pozt",
  "block.minecraft.waxed_weathered_copper_grate": "Shiny Yucky Copurr Holz",
  "block.minecraft.waxed_weathered_copper_lantern": "Shineh Yucky Copurr Lanturn",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Shiny Yucky Copur Trepnoor",
  "block.minecraft.waxed_weathered_cut_copper": "Shiny Yucky old sliced copurr",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Shiny Yucky Slicd Copurr Half Blok",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Shiny Yucky Slicd Copurr Sterz",
  "block.minecraft.waxed_weathered_lightning_rod": "Shineh Yucky Liting Rot",
  "block.minecraft.weathered_chiseled_copper": "Yucky Pretteh Copurr",
  "block.minecraft.weathered_copper": "Yucky Copurr",
  "block.minecraft.weathered_copper_bars": "Yucky Copurr Jeil Bahz",
  "block.minecraft.weathered_copper_bulb": "Yucky Copurr Bob",
  "block.minecraft.weathered_copper_chain": "Yuckeh Copurr Shain",
  "block.minecraft.weathered_copper_chest": "Yucky Copurr Bokz",
  "block.minecraft.weathered_copper_door": "Yucky Copur Noor",
  "block.minecraft.weathered_copper_golem_statue": "Yuckeh Copurr Caty Scratchin Pozt",
  "block.minecraft.weathered_copper_grate": "Yucky Copurr Holz",
  "block.minecraft.weathered_copper_lantern": "Yuckeh Copurr Lanturn",
  "block.minecraft.weathered_copper_trapdoor": "Yucky Copur Trepdoor",
  "block.minecraft.weathered_cut_copper": "Yuckeh slised copurr",
  "block.minecraft.weathered_cut_copper_slab": "Yuckeh slised copurr halfblok",
  "block.minecraft.weathered_cut_copper_stairs": "Yuckeh slised copurr sters",
  "block.minecraft.weathered_lightning_rod": "Yucky Liting Rot",
  "block.minecraft.weeping_vines": "oh no y u cry roof noddle",
  "block.minecraft.weeping_vines_plant": "sad noodle plant",
  "block.minecraft.wet_sponge": "wet Spangblob",
  "block.minecraft.wheat": "Wheat Crops",
  "block.minecraft.white_banner": "blenk bahnor",
  "block.minecraft.white_bed": "Waite Bed",
  "block.minecraft.white_candle": "Wite land pikl",
  "block.minecraft.white_candle_cake": "Caek wif Wite Land pickl",
  "block.minecraft.white_carpet": "Waite Cat Rug",
  "block.minecraft.white_concrete": "Wyte tough bluk",
  "block.minecraft.white_concrete_powder": "Wayte tough bluk powdr",
  "block.minecraft.white_glazed_terracotta": "Wayte mosaic",
  "block.minecraft.white_shulker_box": "Waite Shulker Bux",
  "block.minecraft.white_stained_glass": "Wite Staind Glas",
  "block.minecraft.white_stained_glass_pane": "Whitty Glazz Payn",
  "block.minecraft.white_terracotta": "Waite Terrakattah",
  "block.minecraft.white_tulip": "Wite tulehp",
  "block.minecraft.white_wool": "Waite Fur Bluk",
  "block.minecraft.wildflowers": "Weed but pretier",
  "block.minecraft.wither_rose": "Wither Roos",
  "block.minecraft.wither_skeleton_skull": "Wither Skellyton Skul",
  "block.minecraft.wither_skeleton_wall_skull": "Wither Skellyton Wall",
  "block.minecraft.yellow_banner": "yelloh bahnor",
  "block.minecraft.yellow_bed": "Banana Bed",
  "block.minecraft.yellow_candle": "Yello land pikl",
  "block.minecraft.yellow_candle_cake": "Caek Wif Yelow Candle",
  "block.minecraft.yellow_carpet": "Yello Cat Rug",
  "block.minecraft.yellow_concrete": "Yello tough bluk",
  "block.minecraft.yellow_concrete_powder": "Yellow tough bluk powdr",
  "block.minecraft.yellow_glazed_terracotta": "Yellow mosaic",
  "block.minecraft.yellow_shulker_box": "Yello Shulker Bux",
  "block.minecraft.yellow_stained_glass": "Yelo Staned Glas",
  "block.minecraft.yellow_stained_glass_pane": "Yelo Staned Glas Pan",
  "block.minecraft.yellow_terracotta": "Yollo Terrakattah",
  "block.minecraft.yellow_wool": "Yello Fur Bluk",
  "block.minecraft.zombie_head": "Bad Hooman Hed",
  "block.minecraft.zombie_wall_head": "Ded Person Wall Hed",
  "item.minecraft.acacia_boat": "Akacia Watr Car",
  "item.minecraft.acacia_chest_boat": "Acashuh Watr Car wit Cat Box",
  "item.minecraft.allay_spawn_egg": "flyin blu mob spon ec",
  "item.minecraft.amethyst_shard": "Purpur shinee pice",
  "item.minecraft.angler_pottery_shard": "Cat fud ancient containr thingy",
  "item.minecraft.angler_pottery_sherd": "Cat fud ancient containr thingy",
  "item.minecraft.apple": "Mapple",
  "item.minecraft.archer_pottery_shard": "Bowman ancient containr thingy",
  "item.minecraft.archer_pottery_sherd": "Bowman ancient containr thingy",
  "item.minecraft.armadillo_scute": "Hard Bawl Stuf",
  "item.minecraft.armadillo_spawn_egg": "hard bawl spon ec",
  "item.minecraft.armor_stand": "Stick hooman",
  "item.minecraft.arms_up_pottery_shard": "Human Bing ancient containr thingy",
  "item.minecraft.arms_up_pottery_sherd": "Human Bing ancient containr thingy",
  "item.minecraft.arrow": "ERROW",
  "item.minecraft.axolotl_bucket": "Bukkit wit KUTE PINK FISHH",
  "item.minecraft.axolotl_spawn_egg": "KUTE PINK FISH spon ec",
  "item.minecraft.baked_potato": "Bak'd Pootato",
  "item.minecraft.bamboo_chest_raft": "Stik Watuh Ka wit Cat Box",
  "item.minecraft.bamboo_raft": "stick boat",
  "item.minecraft.bat_spawn_egg": "Bad spon ec",
  "item.minecraft.bee_spawn_egg": "B spon ec",
  "item.minecraft.beef": "Spotty meet",
  "item.minecraft.beetroot": "Betrut",
  "item.minecraft.beetroot_seeds": "Betrut seds",
  "item.minecraft.beetroot_soup": "Betrut supe",
  "item.minecraft.birch_boat": "Burch Watr Car",
  "item.minecraft.birch_chest_boat": "Birtch Watr Car wit Cat Box",
  "item.minecraft.black_bundle": "Spooky powch",
  "item.minecraft.black_dye": "Ender powder",
  "item.minecraft.black_harness": "Blak Happy-dle :D",
  "item.minecraft.blade_pottery_shard": "Surwd ancient containr thingy",
  "item.minecraft.blade_pottery_sherd": "Surwd ancient containr thingy",
  "item.minecraft.blaze_powder": "HOT DUST",
  "item.minecraft.blaze_rod": "Burnin Stick",
  "item.minecraft.blaze_spawn_egg": "Bleze spon ec",
  "item.minecraft.blue_bundle": "Watur powch",
  "item.minecraft.blue_dye": "Water powder",
  "item.minecraft.blue_egg": "DIAMUNDZ ec",
  "item.minecraft.blue_harness": "Bloo Happy-dle :D",
  "item.minecraft.bogged_spawn_egg": "Boogie spon ec",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt drip",
  "item.minecraft.bone": "Doggy treetz",
  "item.minecraft.bone_meal": "Smashed Skeletun",
  "item.minecraft.book": "lotz of paperz",
  "item.minecraft.bordure_indented_banner_pattern": "Burdur indentd bannr paturn",
  "item.minecraft.bow": "Bowz",
  "item.minecraft.bowl": "boul",
  "item.minecraft.bread": "bred",
  "item.minecraft.breeze_rod": "Wind guy stik",
  "item.minecraft.breeze_spawn_egg": "Brrrrrrrr spon ec",
  "item.minecraft.brewer_pottery_shard": "Medisin ancient containr thingy",
  "item.minecraft.brewer_pottery_sherd": "Medisin ancient containr thingy",
  "item.minecraft.brewing_stand": "Bubbleh",
  "item.minecraft.brick": "Burned Clay",
  "item.minecraft.brown_bundle": "Kofee powch",
  "item.minecraft.brown_dye": "Chocolate powder",
  "item.minecraft.brown_egg": "Schokolate ec",
  "item.minecraft.brown_harness": "Bruwn Happy-dle :D",
  "item.minecraft.brush": "mini broom",
  "item.minecraft.bucket": "Shiny sit-in cold thing",
  "item.minecraft.bundle": "Cat powch",
  "item.minecraft.bundle.empty": "MT",
  "item.minecraft.bundle.empty.description": "Kan hold a mikz stacc of thingz :o",
  "item.minecraft.bundle.full": "Fool",
  "item.minecraft.bundle.fullness": "%s OUt OV %s",
  "item.minecraft.burn_pottery_shard": "fireh ancient containr thingy",
  "item.minecraft.burn_pottery_sherd": "fireh ancient containr thingy",
  "item.minecraft.camel_husk_spawn_egg": "Ripe Banana Hors spon ec",
  "item.minecraft.camel_spawn_egg": "Bumpy Banana Hors spon ec",
  "item.minecraft.carrot": "rebbit treetz",
  "item.minecraft.carrot_on_a_stick": "Bunneh Treetz on a stick",
  "item.minecraft.cat_spawn_egg": "Kitty Cat spon ec",
  "item.minecraft.cauldron": "contain liqwide",
  "item.minecraft.cave_spider_spawn_egg": "Cavspaydur spon ec",
  "item.minecraft.chainmail_boots": "cliky fast bootz1!",
  "item.minecraft.chainmail_chestplate": "BLINNG CHEHST",
  "item.minecraft.chainmail_helmet": "blinghat",
  "item.minecraft.chainmail_leggings": "Bling pantz",
  "item.minecraft.charcoal": "burned w00d",
  "item.minecraft.cherry_boat": "Sakura watr car",
  "item.minecraft.cherry_chest_boat": "Sakura Watr Car wit Cat Box",
  "item.minecraft.chest_minecart": "Minecat wif Cat Box",
  "item.minecraft.chicken": "raw cluck",
  "item.minecraft.chicken_spawn_egg": "Nugget spon ec",
  "item.minecraft.chorus_fruit": "Frute dat Duznt Sing",
  "item.minecraft.clay_ball": "cley prom",
  "item.minecraft.clock": "Tiem tellur",
  "item.minecraft.coal": "ur present",
  "item.minecraft.coast_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Watery drip",
  "item.minecraft.cocoa_beans": "itz poop",
  "item.minecraft.cod": "Roh Cod",
  "item.minecraft.cod_bucket": "Cot buket",
  "item.minecraft.cod_spawn_egg": "Cot spon ec",
  "item.minecraft.command_block_minecart": "Minecrat with Command Blockz",
  "item.minecraft.compass": "Spinny thing",
  "item.minecraft.cooked_beef": "Bad spotty meet",
  "item.minecraft.cooked_chicken": "cooked cluck",
  "item.minecraft.cooked_cod": "Cookd Cod",
  "item.minecraft.cooked_mutton": "Bad wooly meet",
  "item.minecraft.cooked_porkchop": "Toasted Piggeh",
  "item.minecraft.cooked_rabbit": "Warm Jumpin Foodz",
  "item.minecraft.cooked_salmon": "Crisp Pink Nomz",
  "item.minecraft.cookie": "Rainbow burd poizon",
  "item.minecraft.copper_axe": "Copurr Aks",
  "item.minecraft.copper_boots": "Copurr Shoez",
  "item.minecraft.copper_chestplate": "Copurr Vezt",
  "item.minecraft.copper_golem_spawn_egg": "Copurr Kat spon ec",
  "item.minecraft.copper_helmet": "Coppur Hat",
  "item.minecraft.copper_hoe": "Copurr Hoe",
  "item.minecraft.copper_horse_armor": "Copurr Horz Armor",
  "item.minecraft.copper_ingot": "Copurr ingut",
  "item.minecraft.copper_leggings": "Copurr Pantz",
  "item.minecraft.copper_nautilus_armor": "Copurr Shrimp Armur",
  "item.minecraft.copper_nugget": "Copurr Nuggiez",
  "item.minecraft.copper_pickaxe": "Copurr Pikakse",
  "item.minecraft.copper_shovel": "Copurr Spoon",
  "item.minecraft.copper_spear": "Copurr on a stik",
  "item.minecraft.copper_sword": "Copurr Sord",
  "item.minecraft.cow_spawn_egg": "Milk-Maeker spon ec",
  "item.minecraft.creaking_spawn_egg": "Scawy twee spon ec",
  "item.minecraft.creeper_banner_pattern": "bannr paturn",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper churge",
  "item.minecraft.creeper_banner_pattern.new": "Creeper churge bannr paturn",
  "item.minecraft.creeper_spawn_egg": "Creeper spon ec",
  "item.minecraft.crossbow": "Crosbowz",
  "item.minecraft.crossbow.projectile": "Projektile:",
  "item.minecraft.crossbow.projectile.multiple": "PRO-jectil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "PRO-jectil: %s",
  "item.minecraft.cyan_bundle": "Sighun powch",
  "item.minecraft.cyan_dye": "Sky powder",
  "item.minecraft.cyan_harness": "Sighun Happy-dle :D",
  "item.minecraft.danger_pottery_shard": "creepr aw man ancient containr thingy",
  "item.minecraft.danger_pottery_sherd": "creepr aw man ancient containr thingy",
  "item.minecraft.dark_oak_boat": "Blak Oke Watr Car",
  "item.minecraft.dark_oak_chest_boat": "Blak Oak Watr Car wit Cat Box",
  "item.minecraft.debug_stick": "Magik stik",
  "item.minecraft.debug_stick.empty": "%s hash nu pwopewties",
  "item.minecraft.debug_stick.select": "shelekted \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" tu %s",
  "item.minecraft.diamond": "Ooooh shineee!",
  "item.minecraft.diamond_axe": "Dimand Aks",
  "item.minecraft.diamond_boots": "awesome shoes",
  "item.minecraft.diamond_chestplate": "super cool shirt",
  "item.minecraft.diamond_helmet": "very shiny hat",
  "item.minecraft.diamond_hoe": "Deemond Hoe",
  "item.minecraft.diamond_horse_armor": "SUPAH shiny hoofy fur",
  "item.minecraft.diamond_leggings": "amazing pants",
  "item.minecraft.diamond_nautilus_armor": "Deemond Shrimp Armur",
  "item.minecraft.diamond_pickaxe": "Dimand Pikakse",
  "item.minecraft.diamond_shovel": "Dimand Spoon",
  "item.minecraft.diamond_spear": "Deemond on a sticc",
  "item.minecraft.diamond_sword": "shiny sord",
  "item.minecraft.disc_fragment_5": "loud thimg piec",
  "item.minecraft.disc_fragment_5.desc": "Round loud thing - 5",
  "item.minecraft.dolphin_spawn_egg": "doolfin spon ec",
  "item.minecraft.donkey_spawn_egg": "Danky spon ec",
  "item.minecraft.dragon_breath": "Dragunish puff",
  "item.minecraft.dried_kelp": "crunchy sea leaves",
  "item.minecraft.drowned_spawn_egg": "Drawn spon ec",
  "item.minecraft.dune_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Litterbox drip",
  "item.minecraft.echo_shard": "boomerang sund pice",
  "item.minecraft.egg": "Ec",
  "item.minecraft.elder_guardian_spawn_egg": "Ehldur Gardien spon ec",
  "item.minecraft.elytra": "FLYYYYYYYY",
  "item.minecraft.emerald": "shineh green stuff",
  "item.minecraft.enchanted_book": "Shineh Majik Book",
  "item.minecraft.enchanted_golden_apple": "Glowy power apl",
  "item.minecraft.end_crystal": "Endur Cristal",
  "item.minecraft.ender_dragon_spawn_egg": "Ender dwagon spon ec",
  "item.minecraft.ender_eye": "Ey ov Ender",
  "item.minecraft.ender_pearl": "Ender Perl",
  "item.minecraft.enderman_spawn_egg": "Enderman spon ec",
  "item.minecraft.endermite_spawn_egg": "Endermite spon ec",
  "item.minecraft.evoker_spawn_egg": "Evokr spon ec",
  "item.minecraft.experience_bottle": "Buttl wif ur levlz",
  "item.minecraft.explorer_pottery_shard": "Eksplorer ancient containr thingy",
  "item.minecraft.explorer_pottery_sherd": "Eksplorer ancient containr thingy",
  "item.minecraft.eye_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.eye_armor_trim_smithing_template.new": "BLINK BLINK drip",
  "item.minecraft.feather": "Dether",
  "item.minecraft.fermented_spider_eye": "Bad spider bal",
  "item.minecraft.field_masoned_banner_pattern": "Brikz bannr paturn",
  "item.minecraft.filled_map": "Direcshun papeh",
  "item.minecraft.fire_charge": "Fire Punch!",
  "item.minecraft.firework_rocket": "shiny 'splody thing",
  "item.minecraft.firework_rocket.flight": "TIEM OF FLY:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "dis makes da rocket go BOOM BOOM",
  "item.minecraft.firework_star.black": "Blak",
  "item.minecraft.firework_star.blue": "Blew",
  "item.minecraft.firework_star.brown": "Broun",
  "item.minecraft.firework_star.custom_color": "cuztum",
  "item.minecraft.firework_star.cyan": "Nyan",
  "item.minecraft.firework_star.fade_to": "vanish to",
  "item.minecraft.firework_star.flicker": "Sparklies!",
  "item.minecraft.firework_star.gray": "Gray",
  "item.minecraft.firework_star.green": "Grean",
  "item.minecraft.firework_star.light_blue": "Lite Blew",
  "item.minecraft.firework_star.light_gray": "Lite Gray",
  "item.minecraft.firework_star.lime": "Lyem",
  "item.minecraft.firework_star.magenta": "Majenta",
  "item.minecraft.firework_star.orange": "Stampy Colour",
  "item.minecraft.firework_star.pink": "Pynk",
  "item.minecraft.firework_star.purple": "Purpel",
  "item.minecraft.firework_star.red": "Red",
  "item.minecraft.firework_star.shape": "Squiggy shape",
  "item.minecraft.firework_star.shape.burst": "Boom",
  "item.minecraft.firework_star.shape.creeper": "Creepery",
  "item.minecraft.firework_star.shape.large_ball": "BIG ball",
  "item.minecraft.firework_star.shape.small_ball": "Tine",
  "item.minecraft.firework_star.shape.star": "pointi shaep",
  "item.minecraft.firework_star.trail": "Liens",
  "item.minecraft.firework_star.white": "Wite",
  "item.minecraft.firework_star.yellow": "Yello",
  "item.minecraft.fishing_rod": "kitteh feedin' device",
  "item.minecraft.flint": "sharpy rock",
  "item.minecraft.flint_and_steel": "frint und steal",
  "item.minecraft.flow_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Windeh drip",
  "item.minecraft.flow_banner_pattern": "Bannr paturn",
  "item.minecraft.flow_banner_pattern.desc": "Windeh",
  "item.minecraft.flow_banner_pattern.new": "Windeh bannr paturn",
  "item.minecraft.flow_pottery_sherd": "Windeh ancient containr thingy",
  "item.minecraft.flower_banner_pattern": "bahnor patturnn",
  "item.minecraft.flower_banner_pattern.desc": "Flowerpower in Charge",
  "item.minecraft.flower_banner_pattern.new": "Flowajh churge bannr paturn",
  "item.minecraft.flower_pot": "container for all the pretty plantz",
  "item.minecraft.fox_spawn_egg": "Fuxe spon ec",
  "item.minecraft.friend_pottery_shard": "Gud kat ancient containr thingy",
  "item.minecraft.friend_pottery_sherd": "Frend ancient containr thingy",
  "item.minecraft.frog_spawn_egg": "toad spon ec",
  "item.minecraft.furnace_minecart": "Minecat wif Hot Box",
  "item.minecraft.ghast_spawn_egg": "Ghast spon ec",
  "item.minecraft.ghast_tear": "Ghast Tear",
  "item.minecraft.glass_bottle": "GLAS BOTUL",
  "item.minecraft.glistering_melon_slice": "glistrin melooon sliz",
  "item.minecraft.globe_banner_pattern": "bahnor patturnn",
  "item.minecraft.globe_banner_pattern.desc": "Glolbe",
  "item.minecraft.globe_banner_pattern.new": "Glolbe bannr paturn",
  "item.minecraft.glow_berries": "shiny berriz",
  "item.minecraft.glow_ink_sac": "Shiny ink sac",
  "item.minecraft.glow_item_frame": "Brite item holdr",
  "item.minecraft.glow_squid_spawn_egg": "Shiny skwid spon ec",
  "item.minecraft.glowstone_dust": "Glowstone duzt",
  "item.minecraft.goat_horn": "monten shep's sharp thingy",
  "item.minecraft.goat_spawn_egg": "monten shep spon ec",
  "item.minecraft.gold_ingot": "GULDEN INGUT",
  "item.minecraft.gold_nugget": "Krispy chikn nuget",
  "item.minecraft.golden_apple": "GULD APEL",
  "item.minecraft.golden_axe": "Goldan Aks",
  "item.minecraft.golden_boots": "GULD BOOTZ",
  "item.minecraft.golden_carrot": "GULDEN CARRUT",
  "item.minecraft.golden_chestplate": "GOLDEN CHESPLAET",
  "item.minecraft.golden_helmet": "GULDEN HAT",
  "item.minecraft.golden_hoe": "Goldn Hoe",
  "item.minecraft.golden_horse_armor": "Goden Horz Armar",
  "item.minecraft.golden_leggings": "GOLD PATNZ",
  "item.minecraft.golden_nautilus_armor": "Guld Shrimp Armur",
  "item.minecraft.golden_pickaxe": "Goldan Pikakse",
  "item.minecraft.golden_shovel": "Goldan Shaval",
  "item.minecraft.golden_spear": "Guld on a stick",
  "item.minecraft.golden_sword": "Goldan Sord",
  "item.minecraft.gray_bundle": "Ash powch",
  "item.minecraft.gray_dye": "Ashes",
  "item.minecraft.gray_harness": "Gray Happy-dle :D",
  "item.minecraft.green_bundle": "Grasy powch",
  "item.minecraft.green_dye": "Grass powder",
  "item.minecraft.green_harness": "Gren Happy-dle :D",
  "item.minecraft.guardian_spawn_egg": "Gardien spon ec",
  "item.minecraft.gunpowder": "Ganpoudar",
  "item.minecraft.guster_banner_pattern": "Bannr paturn",
  "item.minecraft.guster_banner_pattern.desc": "Bloweh",
  "item.minecraft.guster_banner_pattern.new": "Bloweh bannr paturn",
  "item.minecraft.guster_pottery_sherd": "Bloweh ancient containr thingy",
  "item.minecraft.happy_ghast_spawn_egg": "Happeezz Ghast spon ec",
  "item.minecraft.harness": "Happy-dle :D",
  "item.minecraft.heart_of_the_sea": "Hart of da see",
  "item.minecraft.heart_pottery_shard": "<3 ancient containr thingy",
  "item.minecraft.heart_pottery_sherd": "<3 ancient containr thingy",
  "item.minecraft.heartbreak_pottery_shard": "Hartbrek ancient containr thingy",
  "item.minecraft.heartbreak_pottery_sherd": "</3 ancient containr thingy",
  "item.minecraft.hoglin_spawn_egg": "Hoglin spon ec",
  "item.minecraft.honey_bottle": "huny buttle",
  "item.minecraft.honeycomb": "honyconb",
  "item.minecraft.hopper_minecart": "Minecat wif hoppez",
  "item.minecraft.horse_spawn_egg": "Hors spon ec",
  "item.minecraft.host_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host drip",
  "item.minecraft.howl_pottery_shard": "*AWWWWWWWWWW* ancient containr thingy",
  "item.minecraft.howl_pottery_sherd": "*AWWW* ancient containr thingy",
  "item.minecraft.husk_spawn_egg": "Hask spon ec",
  "item.minecraft.ink_sac": "Squirty nasty stuff",
  "item.minecraft.iron_axe": "Iron Aks",
  "item.minecraft.iron_boots": "Irun Shoes",
  "item.minecraft.iron_chestplate": "Irun Vesst",
  "item.minecraft.iron_golem_spawn_egg": "IRON MAN spon ec",
  "item.minecraft.iron_helmet": "IRUNHAT",
  "item.minecraft.iron_hoe": "Irun Hoe",
  "item.minecraft.iron_horse_armor": "Shiny hoofy fur",
  "item.minecraft.iron_ingot": "Irun Ingot",
  "item.minecraft.iron_leggings": "Irun Pantz",
  "item.minecraft.iron_nautilus_armor": "Irun Shrimp Armur",
  "item.minecraft.iron_nugget": "Steely thingy",
  "item.minecraft.iron_pickaxe": "Iron Pikakse",
  "item.minecraft.iron_shovel": "Iron Shaval",
  "item.minecraft.iron_spear": "Irun on a stik",
  "item.minecraft.iron_sword": "Irun Sowrd",
  "item.minecraft.item_frame": "Kitteh Fraem",
  "item.minecraft.jungle_boat": "Jungo Watr Car",
  "item.minecraft.jungle_chest_boat": "Junglz Watr Car wit Cat Box",
  "item.minecraft.knowledge_book": "Buk of Knawledg",
  "item.minecraft.lapis_lazuli": "blu stuffz",
  "item.minecraft.lava_bucket": "bukkit full of HOT SAUCE",
  "item.minecraft.lead": "Leesh",
  "item.minecraft.leather": "Lethur",
  "item.minecraft.leather_boots": "Lethur Slippurz",
  "item.minecraft.leather_chestplate": "Lethur Jackett",
  "item.minecraft.leather_helmet": "Lethur Kap",
  "item.minecraft.leather_horse_armor": "Leathr Horse Armor",
  "item.minecraft.leather_leggings": "Lethur Pantz",
  "item.minecraft.light_blue_bundle": "Ice powch",
  "item.minecraft.light_blue_dye": "Wet powder",
  "item.minecraft.light_blue_harness": "Lite blu Happy-dle :D",
  "item.minecraft.light_gray_bundle": "Silvuh powch",
  "item.minecraft.light_gray_dye": "Dull powder",
  "item.minecraft.light_gray_harness": "Lite grey Happy-dle :D",
  "item.minecraft.lime_bundle": "Laim powch",
  "item.minecraft.lime_dye": "Nasty powder",
  "item.minecraft.lime_harness": "Liem Happy-dle :D",
  "item.minecraft.lingering_potion": "Lingerin Poshun",
  "item.minecraft.lingering_potion.effect.awkward": "Linnerin Poshun of weird",
  "item.minecraft.lingering_potion.effect.empty": "Linnerin Poshun u Cann Onli Gat in HAX MODE",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Linnerin Poshun ov Fire Rezistance",
  "item.minecraft.lingering_potion.effect.harming": "Linnerin Poshun ov Ouch",
  "item.minecraft.lingering_potion.effect.healing": "Linnerin Poshun ov Healin",
  "item.minecraft.lingering_potion.effect.infested": "Linnerin Poshun ov Bugz",
  "item.minecraft.lingering_potion.effect.invisibility": "Linnerin Poshun ov Hiding",
  "item.minecraft.lingering_potion.effect.leaping": "Linnerin Poshun ov Leapin",
  "item.minecraft.lingering_potion.effect.levitation": "Linnerin Poshun ov Levitashun",
  "item.minecraft.lingering_potion.effect.luck": "Linnerin Poshun ov LOL",
  "item.minecraft.lingering_potion.effect.mundane": "Linnerin Poshun ov Boringnes",
  "item.minecraft.lingering_potion.effect.night_vision": "Linnerin Poshun ov Cat Vishun",
  "item.minecraft.lingering_potion.effect.oozing": "Linnerin Poshun ov Gren stuff",
  "item.minecraft.lingering_potion.effect.poison": "Linnerin Poshun ov Poizzon",
  "item.minecraft.lingering_potion.effect.regeneration": "Linnerin Poshun ov Regenerashun",
  "item.minecraft.lingering_potion.effect.slow_falling": "linnerin poshun uf slowmo fall",
  "item.minecraft.lingering_potion.effect.slowness": "Linnerin Poshun ov Slownez",
  "item.minecraft.lingering_potion.effect.strength": "Linnerin Poshun ov Strength",
  "item.minecraft.lingering_potion.effect.swiftness": "Linnerin Poshun ov Spedz",
  "item.minecraft.lingering_potion.effect.thick": "Linnerin Thig Poshun",
  "item.minecraft.lingering_potion.effect.turtle_master": "Linnerin Poshun of TurTl Boss",
  "item.minecraft.lingering_potion.effect.water": "Linnerin Watr Buttl",
  "item.minecraft.lingering_potion.effect.water_breathing": "Linnerin Poshun ov Watr Breathin",
  "item.minecraft.lingering_potion.effect.weakness": "Linnerin Poshun ov Weaknes",
  "item.minecraft.lingering_potion.effect.weaving": "Linnerin Poshun ov Shedin'",
  "item.minecraft.lingering_potion.effect.wind_charged": "Linnerin Poshun ov Wind boom",
  "item.minecraft.llama_spawn_egg": "Lahmuh spon ec",
  "item.minecraft.lodestone_compass": "loserstone compas",
  "item.minecraft.mace": "Sledjhamuh",
  "item.minecraft.magenta_bundle": "Flawor powch",
  "item.minecraft.magenta_dye": "Warmish powder",
  "item.minecraft.magenta_harness": "Majenta Happy-dle :D",
  "item.minecraft.magma_cream": "Flamin creem",
  "item.minecraft.magma_cube_spawn_egg": "Magmuh cewb spon ec",
  "item.minecraft.mangrove_boat": "Mangroff watr car",
  "item.minecraft.mangrove_chest_boat": "Mangroff Watr Car wif Cat Box",
  "item.minecraft.map": "cleen map",
  "item.minecraft.melon_seeds": "Melan Seds",
  "item.minecraft.melon_slice": "melon sliz",
  "item.minecraft.milk_bucket": "mikk buket!!!",
  "item.minecraft.minecart": "Minecat",
  "item.minecraft.miner_pottery_shard": "Pickakz ancient containr thingy",
  "item.minecraft.miner_pottery_sherd": "Pickakz ancient containr thingy",
  "item.minecraft.mojang_banner_pattern": "bahnor patturnn",
  "item.minecraft.mojang_banner_pattern.desc": "Ting",
  "item.minecraft.mojang_banner_pattern.new": "Ting bannr paturn",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom spon ec",
  "item.minecraft.mourner_pottery_shard": ":( ancient containr thingy",
  "item.minecraft.mourner_pottery_sherd": ":( ancient containr thingy",
  "item.minecraft.mule_spawn_egg": "Mewl spon ec",
  "item.minecraft.mushroom_stew": "A supe of funges",
  "item.minecraft.music_disc_11": "Round loud thing",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Round loud thing",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Round loud thing",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Round loud thing",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Round loud thing",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Round loud thing",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Round loud thing",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Round loud thing",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Kitteh bokz)",
  "item.minecraft.music_disc_far": "Round loud thing",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Round loud thing",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Round loud thing",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Round loud thing",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Round loud thing",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Round loud thing",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Round loud thing",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Round loud thing",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Round loud thing",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Round loud thing",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Round loud thing",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Round loud thing",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Round loud thing",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Wooly meet",
  "item.minecraft.name_tag": "Renaemer",
  "item.minecraft.nautilus_shell": "Naughty shell",
  "item.minecraft.nautilus_spawn_egg": "Wird Shrimp spon ec",
  "item.minecraft.nether_brick": "Nether brik",
  "item.minecraft.nether_star": "Nether Asterisk",
  "item.minecraft.nether_wart": "Icky Nether plant",
  "item.minecraft.netherite_axe": "Netherite ax",
  "item.minecraft.netherite_boots": "Netherite shuz",
  "item.minecraft.netherite_chestplate": "Netherite sweatur",
  "item.minecraft.netherite_helmet": "Netherite hat",
  "item.minecraft.netherite_hoe": "Netherite Hoe",
  "item.minecraft.netherite_horse_armor": "Netherite Horz Armur",
  "item.minecraft.netherite_ingot": "Netherite ingut",
  "item.minecraft.netherite_leggings": "Netherite pantz",
  "item.minecraft.netherite_nautilus_armor": "Netherite Shrimp Armur",
  "item.minecraft.netherite_pickaxe": "Netherite Pikax",
  "item.minecraft.netherite_scrap": "Netherit skrapz",
  "item.minecraft.netherite_shovel": "Netherite shuvl",
  "item.minecraft.netherite_spear": "Netherite on a stic",
  "item.minecraft.netherite_sword": "Netherite swurd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smissinng thingy",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite lvl UP!",
  "item.minecraft.oak_boat": "Ouk Watr Car",
  "item.minecraft.oak_chest_boat": "Oak Watr Car wit Cat Box",
  "item.minecraft.ocelot_spawn_egg": "Oslot spon ec",
  "item.minecraft.ominous_bottle": "skeri botel",
  "item.minecraft.ominous_trial_key": "SpooOOoo-key",
  "item.minecraft.orange_bundle": "Sunneh powch",
  "item.minecraft.orange_dye": "Bright powder",
  "item.minecraft.orange_harness": "Oranj Happy-dle :D",
  "item.minecraft.painting": "Art on a paper",
  "item.minecraft.pale_oak_boat": "Wite Ok Watur Kar",
  "item.minecraft.pale_oak_chest_boat": "Wite Ok Watr Car w/ Cat Bokz",
  "item.minecraft.panda_spawn_egg": "Green Stick Eatar spon ec",
  "item.minecraft.paper": "Papyrus",
  "item.minecraft.parched_spawn_egg": "Dry Bonez spon ec",
  "item.minecraft.parrot_spawn_egg": "Pawet spon ec",
  "item.minecraft.phantom_membrane": "creepy flyin ting mimbrain",
  "item.minecraft.phantom_spawn_egg": "Fantum spon ec",
  "item.minecraft.pig_spawn_egg": "Pic spon ec",
  "item.minecraft.piglin_banner_pattern": "bahnor patturnn",
  "item.minecraft.piglin_banner_pattern.desc": "Nouze",
  "item.minecraft.piglin_banner_pattern.new": "Pinknozz bannr paturn",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin Brut spon ec",
  "item.minecraft.piglin_spawn_egg": "Piglin spon ec",
  "item.minecraft.pillager_spawn_egg": "Pilagur spon ec",
  "item.minecraft.pink_bundle": "Sakura powch",
  "item.minecraft.pink_dye": "Less warmy powder",
  "item.minecraft.pink_harness": "Peank Happy-dle :D",
  "item.minecraft.pitcher_plant": "Bottl plantz",
  "item.minecraft.pitcher_pod": "Bottl seed ball",
  "item.minecraft.plenty_pottery_shard": "RICH ancient containr thingy",
  "item.minecraft.plenty_pottery_sherd": "RICH ancient containr thingy",
  "item.minecraft.poisonous_potato": "no eat iz yukky",
  "item.minecraft.polar_bear_spawn_egg": "Polah bar spon ec",
  "item.minecraft.popped_chorus_fruit": "Popped Frut dat Duznt Sing",
  "item.minecraft.porkchop": "rawr pig",
  "item.minecraft.potato": "Pootato",
  "item.minecraft.potion": "Poshun",
  "item.minecraft.potion.effect.awkward": "Poshun of weird",
  "item.minecraft.potion.effect.empty": "Poshun u Cann Onli Gat in HAX MODE",
  "item.minecraft.potion.effect.fire_resistance": "Poshun ov Fire Rezistance",
  "item.minecraft.potion.effect.harming": "Poshun ov Ouch",
  "item.minecraft.potion.effect.healing": "Poshun ov Healin",
  "item.minecraft.potion.effect.infested": "Poshun ov Bugzz",
  "item.minecraft.potion.effect.invisibility": "Poshun ov Hiding",
  "item.minecraft.potion.effect.leaping": "Poshun ov Leapin",
  "item.minecraft.potion.effect.levitation": "bad flyn",
  "item.minecraft.potion.effect.luck": "Poshun ov LOL",
  "item.minecraft.potion.effect.mundane": "Poshun ov Boringnes",
  "item.minecraft.potion.effect.night_vision": "Poshun ov Cat Vishun",
  "item.minecraft.potion.effect.oozing": "Poshun ov Gren stuf",
  "item.minecraft.potion.effect.poison": "Poshun ov Poizzon",
  "item.minecraft.potion.effect.regeneration": "Poshun ov Regenerashun",
  "item.minecraft.potion.effect.slow_falling": "Poshun of slowmo fall",
  "item.minecraft.potion.effect.slowness": "Poshun ov Slownez",
  "item.minecraft.potion.effect.strength": "chuckz noris pushun",
  "item.minecraft.potion.effect.swiftness": "Poshun ov Spedz",
  "item.minecraft.potion.effect.thick": "Fat Poshun",
  "item.minecraft.potion.effect.turtle_master": "Potiun of TurTl Boss",
  "item.minecraft.potion.effect.water": "Not for katz",
  "item.minecraft.potion.effect.water_breathing": "Poshun ov Watr Breathing",
  "item.minecraft.potion.effect.weakness": "Poshun ov Weaknes",
  "item.minecraft.potion.effect.weaving": "Poshun ov Shedin'",
  "item.minecraft.potion.effect.wind_charged": "Poshun ov Wind booom",
  "item.minecraft.pottery_shard_archer": "Bowman ancient containr thingy",
  "item.minecraft.pottery_shard_arms_up": "Human Bing ancient containr thingy",
  "item.minecraft.pottery_shard_prize": "Shineee ancient containr thingy",
  "item.minecraft.pottery_shard_skull": "Head ancient containr thingy",
  "item.minecraft.powder_snow_bucket": "Bukkit wit Powdr Sno",
  "item.minecraft.prismarine_crystals": "Prizmarine pebblez",
  "item.minecraft.prismarine_shard": "Prizmarine thingy",
  "item.minecraft.prize_pottery_shard": "Shineee ancient containr thingy",
  "item.minecraft.prize_pottery_sherd": "Shineee ancient containr thingy",
  "item.minecraft.pufferfish": "very yukky fishy",
  "item.minecraft.pufferfish_bucket": "Pafforfosh buket!!!",
  "item.minecraft.pufferfish_spawn_egg": "Pufahfis spon ec",
  "item.minecraft.pumpkin_pie": "pie with squash in it",
  "item.minecraft.pumpkin_seeds": "Pumpkez Sedz",
  "item.minecraft.purple_bundle": "Grapz powch",
  "item.minecraft.purple_dye": "Sorta-in-between powder",
  "item.minecraft.purple_harness": "Purrpal Happy-dle :D",
  "item.minecraft.quartz": "Nether cloudz",
  "item.minecraft.rabbit": "Rawr Jumpin Foodz",
  "item.minecraft.rabbit_foot": "Jumpin Foob Fut",
  "item.minecraft.rabbit_hide": "Jumpin Foob Rag",
  "item.minecraft.rabbit_spawn_egg": "Wabit spon ec",
  "item.minecraft.rabbit_stew": "Warm Jumpin Foodz in Bawl",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Farmr drip",
  "item.minecraft.ravager_spawn_egg": "Rivagur spon ec",
  "item.minecraft.raw_copper": "moldy wurst",
  "item.minecraft.raw_gold": "shiny coal",
  "item.minecraft.raw_iron": "RAWWWW irun",
  "item.minecraft.recovery_compass": "Deth findr v1.0",
  "item.minecraft.red_bundle": "Bloody powch",
  "item.minecraft.red_dye": "Mojang powder",
  "item.minecraft.red_harness": "Reed Happy-dle :D",
  "item.minecraft.redstone": "Redstone Dust",
  "item.minecraft.resin_brick": "Yelo stiky brik",
  "item.minecraft.resin_clump": "Yelo poop",
  "item.minecraft.rib_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Boney drip",
  "item.minecraft.rotten_flesh": "Taestz Laik Brokali",
  "item.minecraft.saddle": "Sad-dle :c",
  "item.minecraft.salmon": "Rawr Pink Nomz",
  "item.minecraft.salmon_bucket": "Salmon buket!!!",
  "item.minecraft.salmon_spawn_egg": "Samin spon ec",
  "item.minecraft.scrape_pottery_sherd": "Claw ancient cotainr thingy",
  "item.minecraft.scute": "Hard pice ov thing",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Pillejuh drip",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Buildrman drip",
  "item.minecraft.sheaf_pottery_shard": "Cowfud ancient containr thingy",
  "item.minecraft.sheaf_pottery_sherd": "Cowfud ancient containr thingy",
  "item.minecraft.shears": "Skizzors",
  "item.minecraft.sheep_spawn_egg": "Shep spon ec",
  "item.minecraft.shelter_pottery_shard": "Cat hous ancient containr thingy",
  "item.minecraft.shelter_pottery_sherd": "Cat hous ancient containr thingy",
  "item.minecraft.shield": "Cat protecshun",
  "item.minecraft.shield.black": "Blak cat protecshun",
  "item.minecraft.shield.blue": "Bloo cat protecshun",
  "item.minecraft.shield.brown": "Broun cat protecshun",
  "item.minecraft.shield.cyan": "Sighun cat protecshun",
  "item.minecraft.shield.gray": "Moar dull cat protecshun",
  "item.minecraft.shield.green": "Greenish cat protecshun",
  "item.minecraft.shield.light_blue": "Lite bloo cat protecshun",
  "item.minecraft.shield.light_gray": "Dull cat protecshun",
  "item.minecraft.shield.lime": "Limd cat protecshun",
  "item.minecraft.shield.magenta": "Majenta cat protecshun",
  "item.minecraft.shield.orange": "Ornge cat protecshun",
  "item.minecraft.shield.pink": "Pinky cat protecshun",
  "item.minecraft.shield.purple": "Parpal cat protecshun",
  "item.minecraft.shield.red": "Redish cat protecshun",
  "item.minecraft.shield.white": "Wite cat protecshun",
  "item.minecraft.shield.yellow": "Yello cat protecshun",
  "item.minecraft.shulker_shell": "Shulker Shell",
  "item.minecraft.shulker_spawn_egg": "Shulker spon ec",
  "item.minecraft.sign": "wite a mesige",
  "item.minecraft.silence_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.silence_armor_trim_smithing_template.new": "*shhhhhh* drip",
  "item.minecraft.silverfish_spawn_egg": "Grae fish spon ec",
  "item.minecraft.skeleton_horse_spawn_egg": "Skehlehten hors span ec",
  "item.minecraft.skeleton_spawn_egg": "Skelehten spon ec",
  "item.minecraft.skull_banner_pattern": "bahnor patturnn",
  "item.minecraft.skull_banner_pattern.desc": "Skullz churge",
  "item.minecraft.skull_banner_pattern.new": "Scul charg bannr paturn",
  "item.minecraft.skull_pottery_shard": "Bone ancient containr thingy",
  "item.minecraft.skull_pottery_sherd": "Bone ancient containr thingy",
  "item.minecraft.slime_ball": "boogerz",
  "item.minecraft.slime_spawn_egg": "Sliem spon ec",
  "item.minecraft.smithing_template": "Smissinng thingy",
  "item.minecraft.smithing_template.applies_to": "appliz to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Putt ingut or sharp shiniez",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armur",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Putt a piec ov armur",
  "item.minecraft.smithing_template.armor_trim.ingredients": "butters and sharp shiniez",
  "item.minecraft.smithing_template.ingredients": "da stuff u need:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Putt Netherite ingut",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "blue shiny thingz",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Putt deemond stuffz",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite ingut",
  "item.minecraft.smithing_template.upgrade": "IMPROVE!! ",
  "item.minecraft.sniffer_spawn_egg": "Sniffr spon ec",
  "item.minecraft.snort_pottery_shard": "*snfff* ancient containr thingy",
  "item.minecraft.snort_pottery_sherd": "*snfff* ancient containr thingy",
  "item.minecraft.snout_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Nouze drip",
  "item.minecraft.snow_golem_spawn_egg": "Cold watr hooman spon ec",
  "item.minecraft.snowball": "Cold wet",
  "item.minecraft.spectral_arrow": "Shini Errow",
  "item.minecraft.spider_eye": "Spider bal",
  "item.minecraft.spider_spawn_egg": "Spaydur spon ec",
  "item.minecraft.spire_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Towr drip",
  "item.minecraft.splash_potion": "Throw Poshun",
  "item.minecraft.splash_potion.effect.awkward": "Spleshy Poshun of weird",
  "item.minecraft.splash_potion.effect.empty": "Spleshy Poshun u Cann Onli Gat in HAX MODE",
  "item.minecraft.splash_potion.effect.fire_resistance": "Spleshy Poshun ov Fire Rezistance",
  "item.minecraft.splash_potion.effect.harming": "Spleshy Poshun ov Ouch",
  "item.minecraft.splash_potion.effect.healing": "Spleshy Poshun ov Healin",
  "item.minecraft.splash_potion.effect.infested": "Spleshy Poshun ov Bugz",
  "item.minecraft.splash_potion.effect.invisibility": "Spleshy Poshun ov Hiding",
  "item.minecraft.splash_potion.effect.leaping": "Spleshy Poshun ov Leapin",
  "item.minecraft.splash_potion.effect.levitation": "Spleshy Poshun ov Levitashun",
  "item.minecraft.splash_potion.effect.luck": "Spleshy Poshun ov LOL",
  "item.minecraft.splash_potion.effect.mundane": "Spleshy Poshun ov Boringnes",
  "item.minecraft.splash_potion.effect.night_vision": "Spleshy Poshun ov Cat Vishun",
  "item.minecraft.splash_potion.effect.oozing": "Spleshy Poshun ov Gren mob",
  "item.minecraft.splash_potion.effect.poison": "Spleshy Poshun ov Poizzon",
  "item.minecraft.splash_potion.effect.regeneration": "Spleshy Poshun ov Regenerashun",
  "item.minecraft.splash_potion.effect.slow_falling": "Splashie poshun uf slowmo fall",
  "item.minecraft.splash_potion.effect.slowness": "Spleshy Poshun ov Slownez",
  "item.minecraft.splash_potion.effect.strength": "Spleshy Poshun ov Strength",
  "item.minecraft.splash_potion.effect.swiftness": "Spleshy Poshun ov Spedz",
  "item.minecraft.splash_potion.effect.thick": "Spleshy Thig Poshun",
  "item.minecraft.splash_potion.effect.turtle_master": "Splashie poshun uf TurTl Boss",
  "item.minecraft.splash_potion.effect.water": "Spleshy Watr Buttl",
  "item.minecraft.splash_potion.effect.water_breathing": "Spleshy Poshun ov Watr Breathin",
  "item.minecraft.splash_potion.effect.weakness": "Spleshy Poshun ov Weaknes",
  "item.minecraft.splash_potion.effect.weaving": "Spleshy Poshun ov Shedin'",
  "item.minecraft.splash_potion.effect.wind_charged": "Spleshy Poshun ov Wind boom",
  "item.minecraft.spruce_boat": "Sproos Watr Car",
  "item.minecraft.spruce_chest_boat": "Sprce Watr Car wit Cat Box",
  "item.minecraft.spyglass": "I C U",
  "item.minecraft.squid_spawn_egg": "Sqwid spon ec",
  "item.minecraft.stick": "stik",
  "item.minecraft.stone_axe": "Stone Aks",
  "item.minecraft.stone_hoe": "Ston Hoe",
  "item.minecraft.stone_pickaxe": "Ston Pikkatt",
  "item.minecraft.stone_shovel": "stone spoon",
  "item.minecraft.stone_spear": "Ston on a stik",
  "item.minecraft.stone_sword": "Pointy rock",
  "item.minecraft.stray_spawn_egg": "Strey spon ec",
  "item.minecraft.strider_spawn_egg": "Straydur spon ec",
  "item.minecraft.string": "CAN I HAZ TEH TAIL THING",
  "item.minecraft.sugar": "Switz",
  "item.minecraft.suspicious_stew": "IDK dont eat dat",
  "item.minecraft.sweet_berries": "Sweet Beries",
  "item.minecraft.tadpole_bucket": "buket wit toadpol",
  "item.minecraft.tadpole_spawn_egg": "mini frog spon ec",
  "item.minecraft.tide_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Wavy drip",
  "item.minecraft.tipped_arrow": "Shooty Tihng",
  "item.minecraft.tipped_arrow.effect.awkward": "Shooty Tihng Wit Liqwide Magik",
  "item.minecraft.tipped_arrow.effect.empty": "Shooty Tihng u Cann Onli Gat in HAX MODE",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Speshul Shooty Tignh Dat Makez u Fire Rezistant",
  "item.minecraft.tipped_arrow.effect.harming": "Speshul Shooty Tignh Dat Makez u Ouch",
  "item.minecraft.tipped_arrow.effect.healing": "Speshul Shooty Tignh Dat Makez u Heal",
  "item.minecraft.tipped_arrow.effect.infested": "Speshul Shooty Tignh Dat Makez bugz",
  "item.minecraft.tipped_arrow.effect.invisibility": "Speshul Shooty Tignh Dat Makez u Invizibul",
  "item.minecraft.tipped_arrow.effect.leaping": "Speshul Shooty Tignh Dat Makez u Bunny Cat",
  "item.minecraft.tipped_arrow.effect.levitation": "Speshul Shooty Tignh Dat Makez u Flai",
  "item.minecraft.tipped_arrow.effect.luck": "Speshul Shooty Tignh Dat Makez u LOL",
  "item.minecraft.tipped_arrow.effect.mundane": "Shooty Tihng Wit Liqwide Magik",
  "item.minecraft.tipped_arrow.effect.night_vision": "Speshul Shooty Tignh Dat Makez u Cat Vishun",
  "item.minecraft.tipped_arrow.effect.oozing": "Speshul Shooty Tignh Dat Makez gren slaimz",
  "item.minecraft.tipped_arrow.effect.poison": "Speshul Shooty Tignh Dat Makez u Puiznd",
  "item.minecraft.tipped_arrow.effect.regeneration": "Speshul Shooty Tignh Dat Makez u Reg",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Arruz uf slowmo fall",
  "item.minecraft.tipped_arrow.effect.slowness": "Speshul Shooty Tignh Dat Makez u Slo",
  "item.minecraft.tipped_arrow.effect.strength": "Speshul Shooty Tignh Dat Makez u Powahful",
  "item.minecraft.tipped_arrow.effect.swiftness": "Speshul Shooty Tignh Dat Makez u Fazt",
  "item.minecraft.tipped_arrow.effect.thick": "Shooty Tihng wit poshun",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Arruwz of TurTl Boss",
  "item.minecraft.tipped_arrow.effect.water": "Speshul Shooty Tignh Dat Splashes",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Speshul Shooty Tignh Dat Makez u Breathin undr Watr",
  "item.minecraft.tipped_arrow.effect.weakness": "Speshul Shooty Tignh Dat Makez u Week",
  "item.minecraft.tipped_arrow.effect.weaving": "Speshul Shooty Tignh Dat Makez u Shed",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Speshul Shooty Tignh Dat Makez u Windi",
  "item.minecraft.tnt_minecart": "Boomy Minecat",
  "item.minecraft.torchflower_seeds": "burny flowr seeedz",
  "item.minecraft.totem_of_undying": "Anti-dyin' Totum ",
  "item.minecraft.trader_llama_spawn_egg": "Givr Camel spon ec",
  "item.minecraft.trial_key": "Dungenz Kee",
  "item.minecraft.trident": "Dinglehopper",
  "item.minecraft.tropical_fish": "Weird water thing",
  "item.minecraft.tropical_fish_bucket": "Weird water thing buket!!!",
  "item.minecraft.tropical_fish_spawn_egg": "Trahpicul fish spon ec",
  "item.minecraft.turtle_helmet": "TortL head",
  "item.minecraft.turtle_scute": "pice ov tutrl shell",
  "item.minecraft.turtle_spawn_egg": "TortL spon ec",
  "item.minecraft.vex_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Gosty drip",
  "item.minecraft.vex_spawn_egg": "Vax spon ec",
  "item.minecraft.villager_spawn_egg": "Vilagur spon ec",
  "item.minecraft.vindicator_spawn_egg": "Vindahcaytur spon ec",
  "item.minecraft.wandering_trader_spawn_egg": "Wubterng Truder spon ec",
  "item.minecraft.ward_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Blue scary man drip",
  "item.minecraft.warden_spawn_egg": "Blu shrek spon ec",
  "item.minecraft.warped_fungus_on_a_stick": "Warpt Foongis on a stick",
  "item.minecraft.water_bucket": "WatR Buket",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "find-da-wae drip",
  "item.minecraft.wheat": "Weet",
  "item.minecraft.wheat_seeds": "wit seeds",
  "item.minecraft.white_bundle": "Cloud powch",
  "item.minecraft.white_dye": "Vanilla ice cream powder",
  "item.minecraft.white_harness": "Wait Happy-dle :D",
  "item.minecraft.wild_armor_trim_smithing_template": "Smissinng thingy",
  "item.minecraft.wild_armor_trim_smithing_template.new": "wildin drip",
  "item.minecraft.wind_charge": "Wind Attacc",
  "item.minecraft.witch_spawn_egg": "Wetch spon ec",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither skelehten spon ec",
  "item.minecraft.wither_spawn_egg": "Wither spon ec",
  "item.minecraft.wolf_armor": "Woof Armur",
  "item.minecraft.wolf_spawn_egg": "Wuf spon ec",
  "item.minecraft.wooden_axe": "teh furst chopper",
  "item.minecraft.wooden_hoe": "Wuddn Hoe",
  "item.minecraft.wooden_pickaxe": "Wuddn Pikkatt",
  "item.minecraft.wooden_shovel": "Wuddn Spoon",
  "item.minecraft.wooden_spear": "Wud Chunkz on a stick",
  "item.minecraft.wooden_sword": "Wuddn Sord",
  "item.minecraft.writable_book": "NeRd!",
  "item.minecraft.written_book": "Book 4 Reeding",
  "item.minecraft.yellow_bundle": "Yeelo powch",
  "item.minecraft.yellow_dye": "Banana powder",
  "item.minecraft.yellow_harness": "Yelo Happy-dle :D",
  "item.minecraft.zoglin_spawn_egg": "Zoglin spwn ec",
  "item.minecraft.zombie_horse_spawn_egg": "zorse. spon ec",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombilus spon ec",
  "item.minecraft.zombie_spawn_egg": "Zobi spon ec",
  "item.minecraft.zombie_villager_spawn_egg": "Unded villaguur spon ec",
  "item.minecraft.zombified_piglin_spawn_egg": "Zobifyed Piglin spon ec"
}
export const lol_us = items; 
